import { useEffect, useRef, useState } from "react";
import { Accordion, Button, Card } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { DownArrow } from "../../assets/images";
import { IconDelete, PaperClipIcon, UploadNew } from "../../components/Icon";
import ItemTable from "../../components/InvoiceGeneration/ItemTable";
import {
  CommonHeader,
  ConfirmationModal,
  ErrorSuccessModal,
  Loader,
  UploadModal,
} from "../../components/commons";
import { DOUBLE_ENTRY_ITEM_HEADER } from "../../constant/doubleEntryHeadersConst";
import SingleInput from "./SingleInput";

import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";

import { resetSession } from "../../redux/auth";
import { resetInvoiceStatusCode } from "../../redux/invoicing";

import { useLocation } from "react-router-dom";

import { RadioTypes } from "../../commonTypes/universalTypes";
import ShippingAddressTab from "../../components/InvoiceGeneration/ShippingAddress.tsx";
import {
  checkSameUserId,
  formatDate,
  handleDate,
  reverseDate,
  twoDigitAfterDecimel,
} from "../../utils/commonFunctions";

import {
  getAllBusinessAddressAction,
  getAllCustomerSupplierAction,
  getAllExpensesLedgersListAction,
  getAllIncomeLedgersListAction,
  getAllLedgersListAction,
  getAllStockItemListAction,
  getAllTypesLedgerListAction,
  getSingleCustomerSupplierAction,
  getStockMappedBatchListAction,
  multipleUploadFilesAction,
  resetCustomerSupplierList,
  resetMappedStockBatchList,
  resetMappedStockBatchListTotalCount,
  resetMultipleFileUploadData,
  resetMultipleFileUploadError,
  resetSingleCustomerSupplier,
} from "../../redux/clientSettings";
import {
  addInvoiceGenerationAction,
  approveInvoiceAction,
  checkDuplicateEntryAction,
  copyInvoiceGenerationAction,
  getAllMappedClientColumnListAction,
  getInvoiceAllComment,
  getSingleInvoiceDetailsAction,
  invoiceNotesListAction,
  postInvoiceAllComment,
  postInvoiceOcrAction,
  resetApprovalSuccess,
  resetDuplicateEntry,
  resetInvoiceNotesList,
  resetMappedExpensesColumnList,
  resetMappedRevenueColumnList,
  resetSingleInvoiceDetails,
  resetUpdateInvoiceGenerationError,
  resetUpdateInvoiceGenerationSuccess,
  resetcommentsSuccess,
} from "../../redux/invoiceGeneration";

import moment from "moment";
import toast, { Toaster } from "react-hot-toast";
import {
  GetAllLedgersListPayloadType,
  GetAllStockItemListPayloadType,
  GetSingleCustomerSupplierListPayloadType,
  GetStockMappedBatchListPayloadType,
  StockUploadFilePayloadType,
} from "../../commonTypes/clientSettingsTypes";
import {
  ImageDataType,
  SingleUploadImageDataType,
} from "../../commonTypes/fileManagerTypes";
import {
  AddCommentPayloadType,
  AddInvoiceGenerationPayloadType,
  ApproveInvoicePayloadType,
  DuplicateEntriesPayloadType,
  GetAllMappedClientColumnsPayloadType,
  GetCommentPayloadType,
  GetSingleInvoiceDetailsOcrPayloadType,
  InvoiceNotesPayloadType,
  IsGstPresentType,
} from "../../commonTypes/invoiceGenerationTypes";
import {
  GetAllMasterDataCurrencyPayloadType,
  GetCurrencyExchangeDetailsPayloadType,
  GetUsersDepartmentPayloadType,
} from "../../commonTypes/masterDataTypes";
import ImagePreview from "../../components/FileManager/Files/ImagePreview";
import CustomerSupplierModal from "../../components/InvoiceGeneration/CustomerSupplierModal";
import InvoiceCommentsModal from "../../components/InvoiceGeneration/InvoiveCommentsModal";
import UploadModalWithFileManager from "../../components/InvoiceGeneration/UploadModal/UploadModalWithFileManager";
import {
  EXPENSESTYPE,
  REVENUESTYPE,
  STATES_LIST_WITH_CODE,
} from "../../constant/stateListConstants";
import useDebounce from "../../customHooks/useDebounce";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { LoginResponseType } from "../../redux/auth/authTypes";
import {
  InvoiceGenerationCategoryType,
  InvoiceNotesListType,
} from "../../redux/invoiceGeneration/invoiceGenrationTypes";
import {
  getAllMasterDataCurrencyAction,
  getCurrencyExchangeAction,
  getMasterDataUsersDepartmentAction,
  resetCurrencyExchangeDetails,
  resetMasterError,
  resetMasterSuccess,
} from "../../redux/masterData";
import { CurrencyExchangeDetailsType } from "../../redux/masterData/masterTypes";
import {
  RADIO_OPTIONS,
  addShippingAddress,
  autoCalculation,
  resetShippingAddressData,
  resettingGstOnEdit,
} from "../../utils/invoiceGeneration";
import {
  downloadLink,
  imagePreview,
  renderUploadedFiles,
} from "../../utils/invoiceGeneration/commonFunctions";
import "./invoiceGeneration.scss";
import TdsTcs from "../../components/InvoiceGeneration/TdsTcs";
import OcrDropZone from "../../components/InvoiceGeneration/Ocr/OcrDropZone";
import SinglePreviewWithApi from "../../components/commons/Upload/SinglePreviewWithApi";

const OPTIONS: any = {
  branch: [],
  supplier_name: [],
  nature_of_expense: [],
  mode_of_payment: [],
  customer_name: [],
  sku_code: [],
  mapping_tax_invoice: [],
  department: [],
  batch_number: [],
};

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

type AppProps = {
  history: any;
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  isDuplicateEntry: null | number;
  fileManagerFetching: boolean;
  clientSettings: any | null;
  singleInvoiceDetails: any | null;
  allTypesLedgersList: any | null;
  fileUploadData: any;
  branch: any | null;
  RADIO_OPTIONS: RadioTypes[];
  singleCustomerSupplier: any;
  currencySign: string | undefined;
  dispatchResetSessionAction: () => void;
  dispatchResetSingleInvoiceDetails: () => void;
  dispatchResetInvoiceStatusCode: () => void;
  dispatchResetMultiFileUploadData: () => void;
  mappedExpensesColumnsList: InvoiceGenerationCategoryType;
  mappedRevenueColumnsList: InvoiceGenerationCategoryType;
  dispatchGetClientColumnListAction: (
    data: GetAllMappedClientColumnsPayloadType
  ) => void;
  dispatchResetUpdateInvoiceGenerationSuccess: () => void;
  dispatchResetUpdateInvoiceGenerationError: () => void;
  dispatchResetMappedExpensesColumnsListAction: () => void;
  dispatchResetMappedRevenueColumnListAction: () => void;
  dispatchGetAllBusinessAddressAction: (data: any) => void;
  dispatchGetAllLedgersListAction: (data: any) => void;
  dispatchGetAllLedgersListActionNoParams: (
    data: GetAllLedgersListPayloadType
  ) => void;
  dispatchGetAllCustomerSupplierAction: (data: any) => void;
  dispatchGetAllIncomeLedgersListAction: (data: any) => void;
  dispatchGetAllExpensesLedgersListAction: (data: any) => void;
  dispatchGetSingleInvoiceDetailsAction: (data: any) => void;
  dispatchGetAllTypesLedgerListAction: (data: any) => void;
  dispatchAddInvoiceGenerationAction: (data: any) => void;
  dispatchCheckDuplicateEntryAction: (data: any) => any;
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) => void;
  allStockItemList?: [] | any[];
  clientSettingsFetching: boolean;
  customerSupplierListTotal: string | number | any;
  dispatchResetCustomerSupplierList: () => void;
  dispatchResetIsDuplicateInvoice: () => void;
  loginData: LoginResponseType;
  dispatchApproveInvoice: (data: ApproveInvoicePayloadType) => void;
  approvalSuccess: null | number;
  commentsSuccess: null | number;
  dispatchResetApprovalSuccess: () => void;
  dispatchResetCommentsSuccess: () => void;
  dispatchGetAllInvoiceCommentsAction: (data: GetCommentPayloadType) => void;
  dispatchPostAllInvoiceCommentsAction: (data: AddCommentPayloadType) => void;
  dispatchPostInvoiceOcrAction: (
    data: GetSingleInvoiceDetailsOcrPayloadType
  ) => void;
  dispatchResetSingleCustomerSupplier: () => void;
  allComments: any;
  lockedRevenueEntriesDate: null | string;
  lockedExpensesEntriesDate: null | string;
  invoiceNotesList: [] | InvoiceNotesListType[];
  dispatchInvoiceNotesList: (data: InvoiceNotesPayloadType) => void;
  dispatchResetInvoiceNotesList: () => void;
  dispatchGetCurrencyExchangeAction: (
    data: GetCurrencyExchangeDetailsPayloadType
  ) => void;
  dispatchGetAllMasterDataCurrencyList: (
    data: GetAllMasterDataCurrencyPayloadType
  ) => void;
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) => void;
  dispatchResetCurrencyExchangeDetails: () => void;
  masterDataCurrencyListTotal: string | number;
  masterDataCurrencyListing: any;
  currencyExchangeDetails: CurrencyExchangeDetailsType | undefined;
  currencyExchangeSuccess: number | null;
  currencyExchangeError: string | null;
  dispatchResetMasterError: () => void;
  dispatchResetMasterSuccess: () => void;
  clientCurrencyName: string | undefined;
  clientCurrencyShortForm: string | undefined;
  userDepartmentList: any[] | [];
  userDepartmentTotalCount: number;
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  dispatchGetStockMappedBatchListAction: (
    data: GetStockMappedBatchListPayloadType
  ) => void;
  dispatchResetMappedStockBatchList: () => void;
  dispatchResetMappedStockBatchListTotalCount: () => void;
  mappedStockBatchList: any;
  mappedStockBatchListTotalCount: number;
};

const AddOcrInvoice = ({
  history,
  token,
  fetching,
  success,
  error,
  fileUploadData,
  statusCode,
  currencySign,
  clientSettings,
  singleInvoiceDetails,
  allTypesLedgersList,
  fileManagerFetching,
  singleCustomerSupplier,
  isDuplicateEntry,
  dispatchResetMultiFileUploadData,
  dispatchAddInvoiceGenerationAction,
  dispatchGetClientColumnListAction,
  dispatchResetSingleInvoiceDetails,
  dispatchGetSingleInvoiceDetailsAction,
  dispatchGetAllTypesLedgerListAction,
  dispatchResetUpdateInvoiceGenerationError,
  dispatchResetUpdateInvoiceGenerationSuccess,
  dispatchResetMappedExpensesColumnsListAction,
  dispatchResetMappedRevenueColumnListAction,
  mappedExpensesColumnsList,
  mappedRevenueColumnsList,
  dispatchGetAllBusinessAddressAction,
  dispatchGetAllLedgersListAction,
  dispatchGetAllCustomerSupplierAction,
  dispatchGetAllIncomeLedgersListAction,
  dispatchGetAllExpensesLedgersListAction,
  dispatchResetSessionAction,
  dispatchGetAllStockItem,
  dispatchCheckDuplicateEntryAction,
  allStockItemList,
  clientSettingsFetching,
  customerSupplierListTotal,
  lockedRevenueEntriesDate,
  lockedExpensesEntriesDate,
  dispatchResetCustomerSupplierList,
  dispatchResetIsDuplicateInvoice,
  loginData,
  dispatchApproveInvoice,
  approvalSuccess,
  commentsSuccess,
  dispatchResetApprovalSuccess,
  dispatchResetCommentsSuccess,
  dispatchGetAllInvoiceCommentsAction,
  dispatchPostAllInvoiceCommentsAction,
  allComments,
  dispatchPostInvoiceOcrAction,
  dispatchResetSingleCustomerSupplier,
  dispatchInvoiceNotesList,
  invoiceNotesList,
  dispatchResetInvoiceNotesList,
  dispatchGetAllMasterDataCurrencyList,
  dispatchGetCurrencyExchangeAction,
  masterDataCurrencyListTotal,
  masterDataCurrencyListing,
  currencyExchangeDetails,
  dispatchResetCurrencyExchangeDetails,
  currencyExchangeSuccess,
  currencyExchangeError,
  dispatchResetMasterSuccess,
  dispatchResetMasterError,
  clientCurrencyName,
  clientCurrencyShortForm,
  userDepartmentList,
  userDepartmentTotalCount,
  dispatchGetMasterDataUsersDepartmentAction,
  dispatchUploadFilesAction,
  dispatchGetStockMappedBatchListAction,
  dispatchResetMappedStockBatchList,
  dispatchResetMappedStockBatchListTotalCount,
  mappedStockBatchList,
  mappedStockBatchListTotalCount,
}: AppProps) => {
  let invoice_id: any;
  const search = useLocation().search;
  const clientCode = new URLSearchParams(search).get("client_code");
  const companyName = new URLSearchParams(search).get("company_name");
  let params = new URL(window?.location.toString()).searchParams;
  let type = params.get("type");
  const client_url = window.location.pathname.split("/");
  let client_code = Number(client_url && client_url[client_url.length - 1]);
  if (client_url[2] === "copy") {
    invoice_id = Number(client_url && client_url[client_url.length - 2]);
  }
  const [showOcrFileUploadModal, setShowOcrFileUploadModal] = useState(true);
  const [primaryData, setPrimaryData] = useState<any[]>([]);
  const [itemData, setItemData] = useState<any>({});
  const [itemCol, setItemCol] = useState<any[]>([]);
  const [itemDataTemp, setItemDataTemp] = useState<any>([]);
  const [paymentData, setPaymentData] = useState<any>({});
  const [showModal, setShowModal] = useState(false);
  const [selectOption, setSelectOption] = useState(OPTIONS);
  const [uploadData, setUploadData] = useState<any>([]);
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  const [totalValue, setTotalValue] = useState<number>(0);
  const [tds, setTds] = useState<number>(0);
  const [tcs, setTcs] = useState<number>(0);
  const [changeTCSTDSRadioValue, setChangeTCSTDSRadioValue] = useState("TDS");
  const [editItemIndex, setEditItemIndex] = useState<any>(null);
  const [departmentText, setDepartmentText] = useState("");
  const [departmentOffset, setDepartmentOffset] = useState(0);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newCount, setNewCount] = useState(0);
  const [showAddCustomerSupplierModal, setShowAddCustomerSupplierModal] =
    useState<boolean>(false);

  const [stockItem, setStockItem] = useState<any[]>([]);
  const [limit, setLimit] = useState<number>(20);
  const [offset, setOffset] = useState<number>(0);
  const [text, setText] = useState("");
  const [customerSupplierListTotalData, setCustomerSupplierListTotalData] =
    useState("");
  const [convert, setConvert] = useState(false);
  const [currencyText, setCurrencyText] = useState<string>("");

  const [tcsTdsData, setTcsTdsData] = useState({
    type: "",
    id: 0,
    amount: 0,
    rate: 0,
    section_name: "",
  });
  const [tdsTcsvalue, setTdsTcsValue] = useState({
    label: "Select..",
    value: null,
    id: 0,
    section_name: "",
  });
  const [tdstcsChanges, setTdsChanges] = useState(false);
  //===========================User Management=======================================
  const [isAddCustomerSupplierPresent, setIsAddCustomerSupplierPresent] =
    useMenuCheck();
  const [isExpenseApprovalPresent, setIsExpenseApprovalPresent] =
    useMenuCheck();
  const [isRevenueApprovalPresent, setIsRevenueApprovalPresent] =
    useMenuCheck();
  const [isExpenseCommentApprovalPresent, setIsExpenseCommentApprovalPresent] =
    useMenuCheck();
  const [isRevenueCommentApprovalPresent, setIsRevenueCommentApprovalPresent] =
    useMenuCheck();
  const [isEditExpenseInvoicePresent, setIsEditExpenseInvoicePresent] =
    useMenuCheck();
  const [isEditRevenuesInvoicePresent, setIsEditRevenuesInvoicePresent] =
    useMenuCheck();
  const [isViewExpensesInvoicePresent, setIsViewExpensesInvoicePresent] =
    useMenuCheck();
  //==================================================================================
  const [showDuplicateConfirmModal, setShowDuplicateConfirmModal] =
    useState<boolean>(false);
  const [checkDuplicatePayload, setIsCheckDuplicatePayload] = useState<any>({});
  const [calculationDetails, setCalculationDetails] = useState<any>({
    primaryData: {},
    itemDetailsData: {},
  });
  const [isSkuCode, setIsSkuCode] = useState<boolean>(false);
  const [approved, setApproved] = useState(false);
  const [showInvoiceCommentsModal, setShowInvoiceCommentsModal] =
    useState<boolean>(false);
  const [invoiceData, setInvoiceData] = useState<any>(null); //comment model data
  const [isGstPresent, setIsGstPresent] = useState<IsGstPresentType>({
    revenue: false,
    expense: false,
  });
  const [imageDetails, setImageDetails] = useState<SingleUploadImageDataType>({
    fileUrl: "",
    fileType: "",
    finalFileName: "",
  });
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);
  const [currentDocumentValue, setCurrentDocumentValue] = useState<any>({});
  const [isTypeChange, setIsTypeChange] = useState<boolean>(false);
  const [confirmChangeType, setConfirmChangeType] = useState(false);
  const [onCancel, setOnCancel] = useState(false);
  const [newDocumentType, setNewDocumentType] = useState("");
  const [shippingAddressColumns, setShippingAddressColumns] = useState<any>([]);
  const [ledgerId, setLedgerId] = useState<any>(null);
  const [invoiceNoteLedgerId, setInvoiceNoteLegerId] = useState(0);
  const [isShippingAddressVisible, setIsShippingAddressVisible] =
    useState<string>(RADIO_OPTIONS[0].id);
  const [clearShippingColumn, setClearShippingColumn] =
    useState<boolean>(false);
  const [isShippingColumnsAssigned, setIsShippingColumnsAssigned] =
    useState<boolean>(false);
  const [doucumentPreviosValue, setDoucumentPreviosValue] = useState<any>([]);
  const [storeDocumentType, setStoreDocumentType] = useState({});
  const [paymentIndex, setPaymentIndex] = useState<number[]>([]);
  const [paymentErrorCount, setPaymentErrorCount] = useState<any>([]);
  const [placeOfSupply, setPlaceOfSupply] = useState("");
  const redirection = localStorage.getItem("isRedirected");
  const [auditSeasonMessage, setAuditSeasonMessage] = useState("");
  const [isEntryLocked, setIsEntryLocked] = useState(false);
  const [customerSupplierValue, setCustomerSupplierValue] = useState(0);
  const [progressValue, setProgressValue] = useState(0);
  const [mappedBatch, setMappedBatch] = useState<any[]>([]);
  const [selectedSkuId, setSelectedSkuId] = useState<string | null>(null);
  const [
    mappedLedgerCustomerSupplierData,
    setMappedLedgerCustomerSupplierData,
  ] = useState<any>({});
  const [showNatureOfConfirmModal, setNatureOfShowConfirmModal] =
    useState(false);

  function calculateTaxableValueSum(data: any) {
    let sum = 0;
    for (const key in data) {
      if (data?.hasOwnProperty(key)) {
        const entries = data[key];
        // eslint-disable-next-line no-loop-func
        entries?.forEach((entry: any) => {
          if (entry?.column_name === "taxable_value" && entry?.column_value) {
            sum += +entry?.column_value;
          }
        });
      }
    }
    return sum;
  }

  // Calculate the sum
  const taxableValueSum = calculateTaxableValueSum(itemData);

  useEffect(() => {
    dispatchResetMasterSuccess();
    // dispatchResetMultiFileUploadData()
    dispatchResetMasterError();
    dispatchResetCurrencyExchangeDetails();
    setIsShippingColumnsAssigned(false);
    setIsShippingAddressVisible(RADIO_OPTIONS[0].id);
    dispatchResetSingleCustomerSupplier();
    setShippingAddressColumns([]);
    setClearShippingColumn(false);
    setOnCancel(false);
    setLedgerId(null);
    setMappedBatch([]);
    dispatchResetMappedStockBatchList();
    dispatchResetMappedStockBatchListTotalCount();
    dispatchResetCustomerSupplierList();
    dispatchResetUpdateInvoiceGenerationError();
    dispatchResetSingleInvoiceDetails();
    dispatchResetUpdateInvoiceGenerationSuccess();
    dispatchResetMappedExpensesColumnsListAction();
    dispatchResetMappedRevenueColumnListAction();
    setIsAddCustomerSupplierPresent("Add Customer/Supplier", "menu");
    setIsExpenseApprovalPresent("Approve Expenses Invoice", "menu");
    setIsRevenueApprovalPresent("Approve Revenues Invoice", "menu");
    setIsExpenseCommentApprovalPresent("Add Expenses Invoice Comment", "menu");
    setIsRevenueCommentApprovalPresent("Add Revenues Invoice Comment", "menu");
    setIsEditExpenseInvoicePresent("Edit Expense Invoicing Advanced", "menu");
    setIsViewExpensesInvoicePresent("View Expenses Invoicing Advanced", "menu");
    setIsEditRevenuesInvoicePresent("Edit Sales Invoicing Advanced", "menu");
    //
    if (token) {
      let finalData: any = {
        token,
        client_code,
        data_req: "enabled",
      };

      dispatchGetClientColumnListAction(finalData);
      dispatchGetAllBusinessAddressAction(finalData);
      dispatchGetAllLedgersListAction(finalData);
      dispatchGetAllIncomeLedgersListAction(finalData);
      dispatchGetAllExpensesLedgersListAction(finalData);
      dispatchGetAllTypesLedgerListAction(finalData);
      dispatchGetAllStockItem(finalData);
      dispatchResetSingleCustomerSupplier();
      if (invoice_id && type) {
        finalData["invoice_id"] = invoice_id;
        finalData["type"] = type;
        dispatchGetSingleInvoiceDetailsAction(finalData);
      }
    }

    return () => {
      setIsCheckDuplicatePayload({});
    };
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    if (fileUploadData?.length > 0) {
      let newFileUploadData: any = JSON.parse(JSON.stringify(uploadData));
      setUploadData({ ...newFileUploadData, column_value: fileUploadData });
    }
  }, [fileUploadData]);

  //Future use reset currency dropdown if there is currencyExchangeError
  // useEffect(() => {
  //   let temp = JSON.parse(JSON.stringify(primaryData));
  //   if (currencyExchangeError?.includes("list not found")) {
  //     temp?.map((item: any) => {
  //       if (item?.column_name === "currency") {
  //         item.column_value = {
  //           value: clientCurrencyName?clientCurrencyName:"India, Rupees",
  //           label: clientCurrencyName?`${clientCurrencyName}(${clientCurrencyShortForm})`:"India, Rupees (INR)",
  //           currencyShortForm:clientCurrencyShortForm,
  //           currencySign:currencySign,
  //         };
  //       }
  //       return item;
  //     });
  //   }
  //   setPrimaryData(temp);
  // }, [currencyExchangeError]);

  // currency list
  useEffect(() => {
    const currencyData = masterDataCurrencyListing?.map((data: any) => {
      return {
        value: data?.currency_name,
        label: `${data?.currency_name} ${
          data?.currency_short_form ? "(" + data?.currency_short_form + ")" : ""
        }`,
        currencySign: data?.currency_sign,
        currencyShortForm: data?.currency_short_form,
      };
    });
    if (offset > 0) {
      setSelectOption({
        ...selectOption,
        currency: [...selectOption?.currency, ...currencyData],
      });
    } else {
      setSelectOption({
        ...selectOption,
        currency: currencyData,
      });
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [masterDataCurrencyListing]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset,
        limit,
        search_term: currencyText,
      };
      if (offset <= +masterDataCurrencyListTotal) {
        dispatchGetAllMasterDataCurrencyList(finalUserData);
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [offset]);

  const fetchNewCurrencyData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      search_term: currencyText,
    };
    dispatchGetAllMasterDataCurrencyList(finalData);
  };

  useDebounce(
    () => {
      if (currencyText) {
        fetchNewCurrencyData(currencyText);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          search_term: currencyText,
        };
        dispatchGetAllMasterDataCurrencyList(finalData);
      }
    },
    500,
    [currencyText]
  );

  //dynamic currency converter
  useEffect(() => {
    let currencyDetails;
    let date;
    for (let key of primaryData) {
      if (key?.column_name === "currency") {
        currencyDetails = key?.column_value;
      }
      if (key?.column_name === "voucher_invoice_date") {
        date = key?.column_value;
      }
    }
    let currency = primaryData?.find(
      (el: any) => el?.column_name == "currency"
    );
    if (date && token && currency?.column_value?.value !== clientCurrencyName) {
      dispatchResetCurrencyExchangeDetails();
      const currencyFinalData = {
        token,
        date: date ? reverseDate(date) : "",
        baseCurrency: currencyDetails?.currencyShortForm,
        symbol: clientCurrencyShortForm ? clientCurrencyShortForm : "INR",
        amount: "1",
      };
      dispatchGetCurrencyExchangeAction(currencyFinalData);
    } else if (currency?.column_value?.value === clientCurrencyName) {
      dispatchResetCurrencyExchangeDetails();
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [
    primaryData?.find((el: any) => el?.column_name == "currency")?.column_value
      ?.value,
    primaryData?.find((el: any) => el?.column_name == "voucher_invoice_date")
      ?.column_value,
  ]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: departmentOffset,
        limit,
        status: 1,
        searchValue: departmentText,
      };
      if (departmentOffset <= +userDepartmentTotalCount) {
        dispatchGetMasterDataUsersDepartmentAction(finalUserData);
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [departmentOffset]);

  const fetchNewDepartmentData = (search: string) => {
    const finalData = {
      token,
      offset: 0,
      limit: 20,
      status: 1,
      searchValue: departmentText,
    };
    dispatchGetMasterDataUsersDepartmentAction(finalData);
  };

  useDebounce(
    () => {
      if (departmentText) {
        setDepartmentOffset(0);
        fetchNewDepartmentData(departmentText);
      } else {
        const finalData = {
          token,
          offset: 0,
          limit,
          status: 1,
          searchValue: "",
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [departmentText]
  );

  //
  useEffect(() => {
    dispatchResetMappedStockBatchList();

    if (selectedSkuId) {
      let finalData = {
        token,
        clientCode: client_code,
        stockId: selectedSkuId,
        isEnable: 1,
      };
      dispatchGetStockMappedBatchListAction(finalData);

      setSelectedSkuId(null);
    }
  }, [selectedSkuId]);

  useEffect(() => {
    if (mappedStockBatchList && mappedStockBatchList.length) {
      let data = mappedStockBatchList?.map((item: any) => {
        let temp = { ...item };
        temp["value"] = item?.batch_id;
        temp["label"] = item?.batch_number;
        item = temp;
        return item;
      });

      setMappedBatch([...data]);
    } else {
      setMappedBatch([]);
    }
  }, [mappedStockBatchList]);

  useEffect(() => {
    let temp = JSON.parse(JSON.stringify(selectOption));
    temp["batch_number"] = mappedBatch;

    setSelectOption(temp);
  }, [mappedBatch]);
  //department
  useEffect(() => {
    const departmentList = userDepartmentList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.department_name,
      };
    });
    if (departmentOffset > 0) {
      setSelectOption({
        ...selectOption,
        department: [...selectOption?.department, ...departmentList],
      });
    } else {
      setSelectOption({
        ...selectOption,
        department: departmentList,
      });
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [userDepartmentList]);

  useEffect(() => {
    if (primaryData?.length) {
      let vocherInvoiceDate = primaryData?.find(
        (item: any) => item?.name === "Voucher/Invoice Date"
      );
      if (!!vocherInvoiceDate?.column_value) {
        let splitedInvoiceDate: string[] = formatDate(
          vocherInvoiceDate?.column_value
        )?.split("-");
        let splitedLockedEntries: string | string[] = "";
        let lockedDate = null;
        let itemDate = null;
        let customerSupplier: any = "";
        if (type === "expenses") {
          splitedLockedEntries = lockedExpensesEntriesDate
            ? lockedExpensesEntriesDate?.split("-")
            : "";
          itemDate = new Date(
            +splitedInvoiceDate[2],
            +splitedInvoiceDate[1] - 1,
            +splitedInvoiceDate[0]
          );
          lockedDate = new Date(
            +splitedLockedEntries[2],
            +splitedLockedEntries[1] - 1,
            +splitedLockedEntries[0]
          );
          customerSupplier = primaryData?.find(
            (e: any) => e.column_name === "supplier_name"
          );
          if (itemDate <= lockedDate) {
            setIsEntryLocked(true);
          } else {
            setIsEntryLocked(false);
          }
        } else {
          splitedLockedEntries = lockedRevenueEntriesDate
            ? lockedRevenueEntriesDate?.split("-")
            : "";
          itemDate = new Date(
            +splitedInvoiceDate[2],
            +splitedInvoiceDate[1] - 1,
            +splitedInvoiceDate[0]
          );
          lockedDate = new Date(
            +splitedLockedEntries[2],
            +splitedLockedEntries[1] - 1,
            +splitedLockedEntries[0]
          );
          customerSupplier = primaryData?.find(
            (e: any) => e.column_name === "customer_name"
          );
          if (itemDate <= lockedDate) {
            setIsEntryLocked(true);
          } else {
            setIsEntryLocked(false);
          }
        }
        if (customerSupplier?.column_value?.ledger_id) {
          setCustomerSupplierValue(customerSupplier?.column_value?.ledger_id);
        }
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [primaryData]);

  const handleSetRadioValue = (radioValue: string) => {
    setIsShippingAddressVisible(radioValue);
  };

  useEffect(() => {
    let temp = JSON.parse(JSON.stringify(selectOption));
    temp["batch_number"] = mappedBatch;

    setSelectOption(temp);
  }, [mappedBatch]);
  useEffect(() => {
    if (isShippingAddressVisible === "0" || clearShippingColumn === true) {
      resetShippingAddressData(
        primaryData,
        shippingAddressColumns,
        setPrimaryData,
        setShippingAddressColumns
      );
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isShippingAddressVisible, clearShippingColumn]);

  useEffect(() => {
    if (
      currentDocumentValue?.column_value?.value === "credit_note" ||
      currentDocumentValue?.column_value?.value === "debit_note"
    ) {
      if (token && client_code) {
        dispatchResetInvoiceNotesList();
        let finalData = {
          token,
          ledger_id: invoiceNoteLedgerId,
          client_code,
          type: type === "expenses" ? "expenses" : "revenues",
        };
        dispatchInvoiceNotesList(finalData);
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [currentDocumentValue?.column_value?.value, invoiceNoteLedgerId]);

  useEffect(() => {
    autoCalculation(itemDataTemp, calculationDetails, setItemDataTemp, type);
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [calculationDetails]);

  useEffect(() => {
    if (singleInvoiceDetails?.invoice_data?.tds_tcs_details?.type) {
      if (singleInvoiceDetails?.invoice_data?.tds_tcs_details?.type === "tds") {
        setChangeTCSTDSRadioValue("TDS");
      } else if (
        singleInvoiceDetails?.invoice_data?.tds_tcs_details?.type === "tcs"
      ) {
        // setTcs(singleInvoiceDetails?.invoice_data?.tds_tcs_details?.amount);
        if (
          singleInvoiceDetails?.invoice_data?.currency_amount_details
            ?.tds_tcs_amount
        ) {
          setTcs(
            singleInvoiceDetails?.invoice_data?.currency_amount_details
              ?.tds_tcs_amount
          );
        } else {
          setTcs(singleInvoiceDetails?.invoice_data?.tds_tcs_details?.amount);
        }
        setChangeTCSTDSRadioValue("TCS");
      }
    }
    if (singleInvoiceDetails?.invoice_data?.primary?.length > 0) {
      let documentType: any = singleInvoiceDetails?.invoice_data?.primary?.find(
        (item: any) => item?.column_name === "document_type"
      );
      setNewDocumentType(documentType?.column_value?.label);
      let segregatedData = addShippingAddress(
        singleInvoiceDetails?.invoice_data?.primary
      );
      setShippingAddressColumns([...segregatedData]);
    }
    singleInvoiceDetails?.invoice_data?.primary?.map((e: any) => {
      if (e.column_name === "bill_from") {
        setCalculationDetails((prev: any) => ({
          ...prev,
          primaryData: {
            ...prev.primaryData,
            [e.column_name]: { state: e?.column_value?.state },
          },
        }));
      }
      if (e.column_name === "supplier_name") {
        setLedgerId(e.column_value?.ledger_id);
        setInvoiceNoteLegerId(e.column_value?.ledger_id);
        setCalculationDetails((prev: any) => ({
          ...prev,
          primaryData: {
            ...prev.primaryData,
            [e.column_name]: { state: e?.column_value?.state },
          },
        }));
      }
      if (e.column_name === "place_of_supply") {
        setCalculationDetails((prev: any) => ({
          ...prev,
          primaryData: {
            ...prev.primaryData,
            [e.column_name]: { value: e?.column_value?.value },
          },
        }));
      }
      if (e.column_name === "customer_name") {
        setLedgerId(e.column_value?.ledger_id);
        setInvoiceNoteLegerId(e.column_value?.ledger_id);
      }
      if (e.column_name === "ship_to_name") {
        if (e.column_value?.shipping_id) {
          setIsShippingAddressVisible(RADIO_OPTIONS[1].id);
        } else {
          setIsShippingAddressVisible(RADIO_OPTIONS[0].id);
        }
      }
      if (e.column_name === "document_type") {
        setCurrentDocumentValue(e);
      }
      if (e.column_name === "voucher_invoice_date") {
        let isPreviousFyYear =
          e?.column_value?.split("-").join(",") <=
          "2023-03-31"?.split("-").join(",");
        if (isPreviousFyYear && loginData?.user_type === 1) {
          setAuditSeasonMessage("You're entering the invoice of FY 2022-23");
        } else {
          setAuditSeasonMessage("");
        }
      }
    });
    if (
      type === "expenses" &&
      singleInvoiceDetails?.invoice_data?.customer_supplier_details
        
    ) {
      setMappedLedgerCustomerSupplierData(
        singleInvoiceDetails?.invoice_data?.customer_supplier_details
        
      );
    } else if (
      type === "revenues" &&
      singleInvoiceDetails?.invoice_data?.customer_supplier_details
       
    ) {
      setMappedLedgerCustomerSupplierData(
        singleInvoiceDetails?.invoice_data?.customer_supplier_details
          
      );
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [singleInvoiceDetails]);

  useEffect(() => {
    if (checkDuplicatePayload.token) {
      if (isDuplicateEntry === 1) {
        setShowDuplicateConfirmModal(true);
      } else if (isDuplicateEntry === 0) {
        dispatchAddInvoiceGenerationAction(checkDuplicatePayload);
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isDuplicateEntry]);

  useEffect(() => {
    if (offset <= +customerSupplierListTotalData) {
      let finalData: any = {
        token,
        client_code,
        limit,
        offset,
        search_term: text,
        data_req: "enabled",
      };
      dispatchGetAllCustomerSupplierAction(finalData);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [offset]);

  useEffect(() => {
    setCustomerSupplierListTotalData(customerSupplierListTotal);
  }, [customerSupplierListTotal]);

  useEffect(() => {
    if (invoiceNotesList?.length) {
      let invoiceNotesListOptions: any =
        invoiceNotesList?.length > 0 &&
        invoiceNotesList.map((item: any) => {
          let temp = {
            value: item?.id,
            label: `Invoice Date= ${
              item?.voucher_invoice_date
                ? formatDate(item?.voucher_invoice_date)
                : ""
            } % Net Amount= ${
              item?.net_amount ? item?.net_amount?.toFixed(2) : ""
            }  ${
              item?.voucher_invoice_number
                ? `% Invoice Number= ` + item?.voucher_invoice_number
                : ""
            }`,
            data: item,
          };
          item = temp;
          return item;
        });
      setSelectOption({
        ...selectOption,
        mapping_tax_invoice: [...invoiceNotesListOptions],
      });
    } else if (invoiceNotesList?.length === 0) {
      setSelectOption({ ...selectOption, mapping_tax_invoice: [] });
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [invoiceNotesList]);

  function searchData() {
    let finalData: any = {
      token,
      client_code,
      limit,
      offset,
      search_term: text,
      data_req: "enabled",
    };
    dispatchGetAllCustomerSupplierAction(finalData);
  }

  useDebounce(
    () => {
      searchData();
    },
    500,
    [text]
  );

  let item: any = {};
  let payment: any = {};
  let primary: any[] = [];
  let updatedItemData: any = {};
  let uploadEdit: any = {};
  if (type && singleInvoiceDetails) {
    //currency conversion for single invoice item data
    for (const itemKey in singleInvoiceDetails?.invoice_data?.item) {
      const lastObject = singleInvoiceDetails?.invoice_data?.item[
        itemKey
      ]?.find(
        (el: any) => el.column_name === "currency_amount_details"
      )?.column_value;

      const newArray = singleInvoiceDetails?.invoice_data?.item[itemKey]?.map(
        (obj: any) => ({
          ...obj,
          column_value: lastObject?.[obj.column_name] || obj.column_value,
        })
      );

      updatedItemData[itemKey] = newArray?.filter(
        (el: any) => el?.column_name !== "currency_amount_details"
      );
    }

    item = updatedItemData ? updatedItemData : {};
    payment = singleInvoiceDetails?.invoice_data?.payment
      ? singleInvoiceDetails?.invoice_data?.payment
      : {};
    primary = singleInvoiceDetails?.invoice_data?.primary
      ? singleInvoiceDetails?.invoice_data?.primary
      : [];
    if (primary && primary[primary.length - 1]) {
      uploadEdit = primary[primary.length - 1];
    }
  }

  let paymentCol = mappedExpensesColumnsList?.payment
    ? mappedExpensesColumnsList?.payment
    : [];

  let revPaymentCol = mappedRevenueColumnsList?.payment
    ? mappedRevenueColumnsList?.payment
    : [];

  useEffect(() => {
    const interval = setInterval(() => {
      if (fetching && success === null) {
        if (progressValue > 70) {
          setProgressValue(89);
          return;
        } else if (progressValue < 100) {
          setProgressValue((prev) => prev + 10);
        }
      } else if (!fetching && success === 1) {
        setProgressValue(100);
        // setStep(2); ///need to remove this is hardcoded line
      }
    }, 1000);

    return () => clearTimeout(interval);
  }, [fetching, success, progressValue]);

  useEffect(() => {
    let finalArray: any = [];
    let mandatoryArray: number[] = [];
    if (Object.values(payment)?.length > 0) {
      Object.values(payment)?.length &&
        Object.values(payment)?.map((data: any, index: number) => {
          let rIdxArray: number[] = [];
          if (type == "expenses") {
            if (data[0]?.column_value) {
              if (!data[1].column_value) {
                rIdxArray.push(1);
              }
              if (!data[2]?.column_value) {
                rIdxArray?.push(2);
              }
            }
            if (data[2]?.column_value) {
              if (!data[0]?.column_value) {
                rIdxArray.push(0);
              }
              if (!data[1]?.column_value) {
                rIdxArray.push(1);
              }
            }

            if (data[1]?.column_value) {
              if (!data[0]?.column_value) {
                rIdxArray.push(0);
              }
              if (!data[2]?.column_value) {
                rIdxArray.push(2);
              }
            }
            finalArray.push(rIdxArray);
          } else if (type === "revenues") {
            if (data[0]?.column_value) {
              if (!data[1]?.column_value) {
                rIdxArray.push(1);
              }
              if (!data[2]?.column_value && data[2]?.sequence === 4) {
                rIdxArray.push(2);
              }
              if (!data[3]?.column_value && data[3]?.sequence === 4) {
                rIdxArray?.push(3);
              }
            }

            if (data[1]?.column_value) {
              if (!data[0]?.column_value) {
                rIdxArray.push(0);
              }
              if (!data[2]?.column_value && data[2]?.sequence === 4) {
                rIdxArray.push(2);
              }
              if (!data[3]?.column_value && data[3]?.sequence === 4) {
                rIdxArray.push(3);
              }
            }
            if (data[2]?.column_value && data[2]?.sequence === 4) {
              if (!data[0]?.column_value) {
                rIdxArray.push(0);
              }
              if (!data[1]?.column_value) {
                rIdxArray.push(1);
              }
            }
            if (data[3]?.column_value && data[3]?.sequence === 4) {
              if (!data[0]?.column_value) {
                rIdxArray.push(0);
              }
              if (!data[1]?.column_value && data[1]?.sequence === 2) {
                rIdxArray.push(1);
              }
            }

            finalArray.push(rIdxArray);
          }
          if (
            (data[0]?.column_name === "net_payment_made" &&
              data[0]?.column_value) ||
            (data[1]?.column_name === "mode_of_payment" &&
              data[1]?.column_value) ||
            (data[2]?.column_name === "dop_in_bank_cash" &&
              data[2]?.column_value) ||
            (data[0]?.column_name === "net_amount_received" &&
              data[0]?.column_value) ||
            (data[1]?.column_name === "mode_of_receipts" &&
              data[1]?.column_value) ||
            (data[2]?.column_name === "dor_in_bank_cash" &&
              data[2]?.column_value) ||
            (data[3]?.column_name === "dor_in_bank_cash" &&
              data[3]?.column_value)
          ) {
            mandatoryArray.push(index);
          }
        });
      setPaymentIndex([...mandatoryArray]);
      setPaymentErrorCount([...finalArray]);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [payment]);

  useEffect(() => {
    if (Object.keys(singleInvoiceDetails)?.length > 0) {
      setShowOcrFileUploadModal(false);
    } else {
      setShowOcrFileUploadModal(true);
    }
    if (type !== "expenses") return;
    let shippingAddressArray = addShippingAddress(primary);
    if (shippingAddressArray?.length === 3) {
      setIsShippingColumnsAssigned(true);
    }
    setShippingAddressColumns(shippingAddressArray);

    let { invoice_data: { invoice_value = 0 } = {} } = singleInvoiceDetails;

    mappedExpensesColumnsList?.item?.map((item: any) => {
      if (item.column_name === "gst_percentage") {
        setIsGstPresent((prev: any) => ({ ...prev, expense: true }));
      }
    });

    setItemData(item);
    setItemCol(mappedExpensesColumnsList?.item || []);
    setPaymentData(payment);
    setPrimaryData(primary);
    setTotalValue(invoice_value);
    if (
      singleInvoiceDetails?.invoice_data?.currency_amount_details
        ?.tds_tcs_amount
    ) {
      setTds(
        singleInvoiceDetails?.invoice_data?.currency_amount_details
          ?.tds_tcs_amount
      );
    } else {
      setTds(singleInvoiceDetails?.invoice_data?.tds_tcs_details?.amount);
    }
    return () => setIsGstPresent({ revenue: false, expense: false });
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [singleInvoiceDetails]);

  useEffect(() => {
    if (type !== "revenues") return;

    let shippingAddressArray = addShippingAddress(primary);
    if (shippingAddressArray?.length === 3) {
      setIsShippingColumnsAssigned(true);
    }
    setShippingAddressColumns(shippingAddressArray);

    let { invoice_data: { invoice_value = 0 } = {} } = singleInvoiceDetails;

    mappedRevenueColumnsList?.item?.map((item: any) => {
      if (item.column_name === "gst_percentage") {
        setIsGstPresent((prev: any) => ({ ...prev, revenue: true }));
      }
    });

    setItemData(item);
    // setItemDataTemp(item);
    setItemCol(mappedRevenueColumnsList?.item || []);
    setPaymentData(payment);
    setPrimaryData(primary);

    setTotalValue(invoice_value);
    if (
      singleInvoiceDetails?.invoice_data?.currency_amount_details
        ?.tds_tcs_amount
    ) {
      setTds(
        singleInvoiceDetails?.invoice_data?.currency_amount_details
          ?.tds_tcs_amount
      );
    } else {
      setTds(singleInvoiceDetails?.invoice_data?.tds_tcs_details?.amount);
    }
  }, [singleInvoiceDetails]);

  useEffect(() => {
    if (allStockItemList && allStockItemList.length) {
      let data = allStockItemList?.map((item: any) => {
        let temp = { ...item };
        temp["value"] = item?.stock_item_id;
        temp["label"] = item?.stock_item_name;
        item = temp;
        return item;
      });

      setStockItem(data);
    }
  }, [allStockItemList]);

  useEffect(() => {
    const temp = JSON.parse(JSON.stringify(itemData));
    let totalValue: number = 0;
    temp &&
      Object.keys(temp).length &&
      Object.keys(temp)?.map((index: any) => {
        temp[index] &&
          temp[index]?.map((item: any) => {
            if (item.column_name === "total_value" && item.column_value) {
              totalValue = twoDigitAfterDecimel(
                totalValue + +item.column_value
              );
            }
          });
      });

    setTotalValue(totalValue);
  }, [itemData]);

  const updateUppliersAddress = (data: any, column: string) => {
    let temp = JSON.parse(JSON.stringify(primaryData));

    temp?.map((item: any) => {
      //expenses
      if (item.column_name === "supplier_address" && column === "supplier_name")
        item.column_value = data?.address;
      if (item.column_name === "supplier_gstn" && column === "supplier_name")
        item.column_value = data?.gst_number;

      //revenues
      //bill from
      if (item.column_name === "address" && column === "bill_from")
        item.column_value = data?.address;
      if (item.column_name === "gst_number" && column === "bill_from")
        item.column_value = data?.gst_number;
      //customer
      if (item.column_name === "customer_address" && column === "customer_name")
        item.column_value = data?.address;
      if (item.column_name === "customer_gstn" && column === "customer_name")
        item.column_value = data?.gst_number;
      if (item.column_name === "bill_from_address1" && column === "bill_from")
        item.column_value = data?.address1;
      if (item.column_name === "bill_from_address2" && column === "bill_from")
        item.column_value = data?.address2;
      if (
        item.column_name === "supplier_address1" &&
        column === "supplier_name"
      )
        item.column_value = data?.supplier_address1;
      if (
        item.column_name === "supplier_address2" &&
        column === "supplier_name"
      )
        item.column_value = data?.address2;

      if (
        item.column_name === "customer_address1" &&
        column === "customer_name"
      )
        item.column_value = data?.address1;
      if (
        item.column_name === "customer_address2" &&
        column === "customer_name"
      )
        item.column_value = data?.address2;
      if (item.column_name === "branch_address1" && column === "branch")
        item.column_value = data?.address1;
      if (item.column_name === "branch_address2" && column === "branch")
        item.column_value = data?.address2;
      return item;
    });

    setPrimaryData(temp);
  };

  useEffect(() => {
    setConvert(false);
    if (clientSettings) {
      let branch = clientSettings?.businessAddressList?.map((item: any) => {
        let temp = { ...item };
        temp["value"] = item?.ledger_id;
        temp["label"] = item?.trade_name;
        temp["state"] = item?.state;
        item = temp;
        return item;
      });

      let supplier_name = clientSettings?.customerSupplierList?.map(
        (item: any) => {
          let temp = { ...item };
          temp["value"] = item?.ledger_id;
          temp["label"] = `${item?.legal_name} (${item?.ledger_number})%${
            item?.trade_name ? item?.trade_name : ""
          }`;
          temp["state"] = item?.state;
          item = temp;
          return item;
        }
      );

      let nature_of_expense = clientSettings?.allShowLedgersList?.map(
        (item: any) => {
          let temp = { ...item };
          temp["value"] = item?.ledger_id;
          temp["label"] = `${item?.ledger_name} (${item?.ledger_number})`;
          item = temp;
          return item;
        }
      );

      let mode_of_payment =
        allTypesLedgersList &&
        allTypesLedgersList?.map((item: any) => {
          let temp = { ...item };
          temp["value"] = item?.ledger_id;
          let correspondingCustomerSupplier =
            clientSettings?.customerSupplierList?.find(
              (csItem: any) => csItem?.ledger_id === item?.ledger_id
            );
          temp["label"] = `${item?.ledger_name} (${item?.ledger_number})%${
            correspondingCustomerSupplier?.trade_name
              ? correspondingCustomerSupplier?.trade_name
              : ""
          }`;
          item = temp;
          return item;
        });

      let mode_of_receipts =
        allTypesLedgersList &&
        allTypesLedgersList?.map((item: any) => {
          let temp = { ...item };
          temp["value"] = item?.ledger_id;
          let correspondingCustomerSupplier =
            clientSettings?.customerSupplierList?.find(
              (csItem: any) => csItem?.ledger_id === item?.ledger_id
            );
          temp["label"] = `${item?.ledger_name} (${item?.ledger_number})%${
            correspondingCustomerSupplier?.trade_name
              ? correspondingCustomerSupplier?.trade_name
              : ""
          }`;
          item = temp;
          return item;
        });

      let temp = JSON.parse(JSON.stringify(selectOption));

      if (type === "revenues") {
        temp["bill_from"] = branch;
        temp["customer_name"] = supplier_name;
        temp["nature_of_income"] = nature_of_expense;
        temp["mode_of_receipts"] = mode_of_receipts;
        temp["sku_code"] = stockItem;
        temp["place_of_supply"] = STATES_LIST_WITH_CODE;
        temp["document_type"] =
          singleInvoiceDetails?.invoice_category === 1 ||
          singleInvoiceDetails?.invoice_category === 2 ||
          singleInvoiceDetails?.invoice_category === 3
            ? REVENUESTYPE?.filter((el) => el.value !== "estimation")
            : REVENUESTYPE;

        if (offset > 0) {
          clientSettingsFetching === false &&
            setSelectOption((prv: any) => {
              return {
                ...prv,
                customer_name: [...prv.customer_name, ...temp.customer_name],
              };
            });
        } else {
          setSelectOption(temp);
        }
      } else {
        temp["branch"] = branch;
        temp["supplier_name"] = supplier_name;
        temp["nature_of_expense"] = nature_of_expense;
        temp["mode_of_payment"] = mode_of_payment;
        temp["sku_code"] = stockItem;
        temp["place_of_supply"] = STATES_LIST_WITH_CODE;
        temp["document_type"] =
          singleInvoiceDetails?.invoice_category === 1 ||
          singleInvoiceDetails?.invoice_category === 2 ||
          singleInvoiceDetails?.invoice_category === 3
            ? EXPENSESTYPE.filter((el) => el.value !== "purchase_order")
            : EXPENSESTYPE;

        if (offset > 0) {
          if (offset <= +customerSupplierListTotal) {
            clientSettingsFetching === false &&
              setSelectOption({
                ...selectOption,
                supplier_name: [
                  ...selectOption.supplier_name,
                  ...temp.supplier_name,
                ],
              });
          }
        } else {
          setSelectOption(temp);
        }
      }
    }
  }, [clientSettings]);

  useEffect(() => {
    if (Array.isArray(singleCustomerSupplier?.shipping_addresses)) {
      let shippingOptions = singleCustomerSupplier?.shipping_addresses.map(
        (item: any) => {
          let temp = { ...item };
          temp["value"] = item?.shipping_id;
          temp["label"] = item?.legal_name;
          item = temp;
          return item;
        }
      );

      setSelectOption({ ...selectOption, ship_to_name: [...shippingOptions] });
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [singleCustomerSupplier]);

  useEffect(() => {
    if (Object.keys(mappedLedgerCustomerSupplierData).length > 0) {
      let updatedData = itemDataTemp?.map((item: any) => {
        if (item?.column_name === "nature_of_expense") {
          if( mappedLedgerCustomerSupplierData?.default_expense_ledger_details
            ?.ledger_id){

              return {
                ...item,
                column_value: {
                  ledger_id:
                  mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                  ?.ledger_id,
              ledger_name:
              mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                  ?.ledger_name,
              ledger_number:
              mappedLedgerCustomerSupplierData?.default_expense_ledger_details
              ?.ledger_number,
              ledger_type:
              mappedLedgerCustomerSupplierData?.default_expense_ledger_details
              ?.type,
            },
          }
          }
          else{
            return item
          };
        } else if (
          item?.column_name === "nature_of_income" &&
          !item?.column_value
        ) {
          if(mappedLedgerCustomerSupplierData?.default_income_ledger_details
            ?.ledger_id){

              return {
                ...item,
                column_value: {
                  ledger_id:
                mappedLedgerCustomerSupplierData?.default_income_ledger_details
                  ?.ledger_id,
              ledger_name:
                mappedLedgerCustomerSupplierData?.default_income_ledger_details
                  ?.ledger_name,
                  ledger_number:
                  mappedLedgerCustomerSupplierData?.default_income_ledger_details
                  ?.ledger_number,
                  ledger_type:
                  mappedLedgerCustomerSupplierData?.default_income_ledger_details
                  ?.type,
                },
              }
              
          }
          else{
            return item
          };
        }
        return item;
      });
      setItemDataTemp([...updatedData]);
    }
  }, [mappedLedgerCustomerSupplierData, showAddModal]);

  const handleChangeItemNatureOfData = () => {
    let updatedData = itemDataTemp?.map((item: any) => {
      if (item?.column_name === "nature_of_expense") {
        return {
          ...item,
          column_value: {
            ledger_id:
              mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                ?.ledger_id,
            ledger_name:
              mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                ?.ledger_name,
            ledger_number:
              mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                ?.ledger_number,
            ledger_type:
              mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                ?.type,
          },
        };
      } else if (item?.column_name === "nature_of_income") {
        return {
          ...item,
          column_value: {
            ledger_id:
              mappedLedgerCustomerSupplierData?.default_income_ledger_details
                ?.ledger_id,
            ledger_name:
              mappedLedgerCustomerSupplierData?.default_income_ledger_details
                ?.ledger_name,
            ledger_number:
              mappedLedgerCustomerSupplierData?.default_income_ledger_details
                ?.ledger_number,
            ledger_type:
              mappedLedgerCustomerSupplierData?.default_income_ledger_details
                ?.type,
          },
        };
      }
      return item;
    });
    setItemDataTemp([...updatedData]);

    const newItemData = JSON.parse(JSON.stringify(itemData));

    Object.keys(newItemData).forEach((key) => {
      newItemData[key] = newItemData[key].map((item: any) => {
        if (item?.column_name === "nature_of_expense") {
          return {
            ...item,
            column_value: {
              ledger_id:
                mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                  ?.ledger_id,
              ledger_name:
                mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                  ?.ledger_name,
              ledger_number:
                mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                  ?.ledger_number,
              ledger_type:
                mappedLedgerCustomerSupplierData?.default_expense_ledger_details
                  ?.type,
            },
          };
        } else if (item?.column_name === "nature_of_income") {
          return {
            ...item,
            column_value: {
              ledger_id:
                mappedLedgerCustomerSupplierData?.default_income_ledger_details
                  ?.ledger_id,
              ledger_name:
                mappedLedgerCustomerSupplierData?.default_income_ledger_details
                  ?.ledger_name,
              ledger_number:
                mappedLedgerCustomerSupplierData?.default_income_ledger_details
                  ?.ledger_number,
              ledger_type:
                mappedLedgerCustomerSupplierData?.default_income_ledger_details
                  ?.type,
            },
          };
        }
        return item;
      });
    });

    setItemData(newItemData);
  };

  const handlePrimaryData = (
    value: any,
    name: string,
    index: number,
    subType: string,
    rIdx?: number,
    address?: any
  ) => {
    setOnCancel(false);
    let newData = JSON.parse(JSON.stringify(primaryData));
    let shippingData = JSON.parse(JSON.stringify(shippingAddressColumns));
    if (name === "voucher_invoice_date") {
      setTdsTcsValue({
        label: "Select..",
        value: null,
        id: 0,
        section_name: "",
      });
      setTds(0);
      setTcs(0);
    }
    if (name === "supplier_name" || name === "customer_name") {
      if (itemData?.length === 0) {
        if(type === "expenses") {
          if(address?.data?.default_expense_ledger_details?.ledger_id){
            setMappedLedgerCustomerSupplierData(address?.data);
          }
          else{
            setMappedLedgerCustomerSupplierData({});

          }
        }
        
        else if(type === "revenues") {
          if(address?.data?.default_income_ledger_details?.ledger_id){

            setMappedLedgerCustomerSupplierData(address?.data);
          }
          else{
            setMappedLedgerCustomerSupplierData({});
          }
        }
        setIsShippingAddressVisible(RADIO_OPTIONS[0].id);
        setClearShippingColumn(true);
        let changeSupplier: any = newData?.find(
          (el: any) => el?.column_name === "mapping_tax_invoice"
        );

        setLedgerId(value?.ledger_id);
        setInvoiceNoteLegerId(value?.ledger_id);
        delete changeSupplier?.column_value;
      } else {
        if(type === "expenses"){

          if( address?.data?.default_expense_ledger_details?.ledger_id) {
             setMappedLedgerCustomerSupplierData(address?.data);
             setNatureOfShowConfirmModal(true);
           }
           else{
             setMappedLedgerCustomerSupplierData({});
             setNatureOfShowConfirmModal(false);
           }
         }
         else if(type === "revenues") {
           if(address?.data?.default_income_ledger_details?.ledger_id){
 
             setMappedLedgerCustomerSupplierData(address?.data);
             setNatureOfShowConfirmModal(true);
           }
           else{
             setMappedLedgerCustomerSupplierData({});
             setNatureOfShowConfirmModal(false);
           }
         }
      }
    }
    if (name === "document_type") {
      setCurrentDocumentValue({ column_value: { value: value?.value } });
      let changeSupplier: any = newData?.find(
        (el: any) => el?.column_name === "mapping_tax_invoice"
      );

      delete changeSupplier?.column_value;
    }
    setCalculationDetails((prev: any) => ({
      ...prev,
      primaryData: { ...prev.primaryData, [name]: value },
    }));
    if (name === "place_of_supply") {
      setCalculationDetails((prev: any) => ({
        ...prev,
        primaryData: { ...prev.primaryData, [name]: { value: value?.value } },
      }));
    }
    if (name === "bill_from") {
      setCalculationDetails((prev: any) => ({
        ...prev,
        primaryData: { ...prev.primaryData, [name]: { state: value?.state } },
      }));
    }
    if (name === "supplier_name") {
      setCalculationDetails((prev: any) => ({
        ...prev,
        primaryData: { ...prev.primaryData, [name]: { state: value?.state } },
      }));
    }
    if (name === "voucher_invoice_date") {
      let checkDate =
        value?.split("-").join(",") <= "2023-03-31"?.split("-").join(",");
      if (!checkDate) {
        setAuditSeasonMessage("");
      } else {
        setAuditSeasonMessage("You're entering the invoice of FY 2022-23");
      }
    }

    if (!subType && index === undefined) return;
    if (name !== "ship_to_name") {
      let temp = newData[index];
      temp.column_value = handleDate(value);
      newData[index] = temp;
    }

    if (address && address.data && address.column) {
      const { data = {}, column = {} } = address;

      newData &&
        newData?.map((item: any) => {
          //expenses
          if (
            item.column_name === "supplier_address" &&
            column === "supplier_name"
          )
            item.column_value = data?.address;
          if (
            item.column_name === "supplier_gstn" &&
            column === "supplier_name"
          )
            item.column_value = data?.gst_number;
          if (
            item.column_name === "supplier_address1" &&
            column === "supplier_name"
          )
            item.column_value = data?.address1;
          if (
            item.column_name === "supplier_address2" &&
            column === "supplier_name"
          )
            item.column_value = data?.address2;
          if (
            item.column_name === "customer_address1" &&
            column === "customer_name"
          )
            item.column_value = data?.address1;
          if (
            item.column_name === "customer_address2" &&
            column === "customer_name"
          )
            item.column_value = data?.address2;
          if (item.column_name === "branch_address1" && column === "branch")
            item.column_value = data?.address1;
          if (item.column_name === "branch_address2" && column === "branch")
            item.column_value = data?.address2;

          //revenues
          //bill from
          if (item.column_name === "address" && column === "bill_from")
            item.column_value = data?.address;
          if (item.column_name === "gst_number" && column === "bill_from")
            item.column_value = data?.gst_number;
          if (
            item.column_name === "bill_from_address1" &&
            column === "bill_from"
          )
            item.column_value = data?.address1;
          if (
            item.column_name === "bill_from_address2" &&
            column === "bill_from"
          )
            item.column_value = data?.address2;
          //customer
          if (
            item.column_name === "customer_address" &&
            column === "customer_name"
          )
            item.column_value = data?.address;
          if (
            item.column_name === "customer_gstn" &&
            column === "customer_name"
          )
            item.column_value = data?.gst_number;

          if (
            item.column_name === "ship_to_name" &&
            column === "ship_to_name"
          ) {
            item.column_value = {
              shipping_id: data?.shipping_id,
              legal_name: data?.legal_name,
            };
          }

          if (
            item.column_name === "ship_to_address" &&
            column === "ship_to_name"
          ) {
            item.column_value = `${data?.address1 ? data?.address1 : ""}${
              data?.address1 && data?.address2 ? " " : ""
            }${data?.address2 ? data?.address2 : ""}`;
          }
          if (item.column_name === "ship_to_gst" && column === "ship_to_name") {
            item.column_value = data?.gst_number;
          }

          return item;
        });
      shippingData?.map((item: any) => {
        if (item.column_name === "ship_to_name" && column === "ship_to_name") {
          setClearShippingColumn(false);
          item.column_value = data;
        }
        if (
          item.column_name === "ship_to_address" &&
          column === "ship_to_name"
        ) {
          item.column_value = `${data?.address1 ? data?.address1 : ""}${
            data?.address1 && data?.address2 ? " " : ""
          }${data?.address2 ? data?.address2 : ""}`;
        }
        if (item.column_name === "ship_to_gst" && column === "ship_to_name") {
          item.column_value = data?.gst_number;
        }
        return item;
      });
    }

    setShippingAddressColumns(shippingData);

    setPrimaryData(newData);
  };

  /* Add Customer/Supplier Modal */
  const handleToggleAddCustomerSupplierModal = () => {
    setShowAddCustomerSupplierModal(!showAddCustomerSupplierModal);
  };
  /* =================== */

  const handleItemData = (
    value: any,
    name: string,
    index: number,
    subType: string,
    rIdx?: number,
    hsn_sac_code?: any
  ) => {
    setCalculationDetails((prev: any) => ({
      ...prev,
      itemDetailsData: { ...prev.itemDetailsData, [name]: value },
    }));
    let newData = JSON.parse(JSON.stringify(itemDataTemp));
    let temp;
    if (subType === "item" && rIdx !== undefined) {
      temp = newData[rIdx][index];
      temp.column_value = value;
      newData[rIdx][index] = temp;
    } else {
      newData[index]["column_value"] = value;
      temp = newData[index];
    }

    if (temp.column_name === "sku_code") {
      newData &&
        newData?.map((item: any) => {
          if (item?.column_name === "batch_number") {
            item.batchOptions = undefined;
            item.column_value = { value: null, label: "" };
          } else {
            return item;
          }
        });
      if (hsn_sac_code && hsn_sac_code.data && hsn_sac_code.column) {
        const { data = {} } = hsn_sac_code;

        newData &&
          newData?.map((item: any) => {
            if (item.column_name === "hsn_sac_code") {
              item.column_value = data;
            }

            return item;
          });

        // setItemDataTemp(newData);
      }
      if (hsn_sac_code && hsn_sac_code.unit) {
        newData &&
          newData?.map((item: any) => {
            if (item.column_name === "unit") {
              item.column_value = hsn_sac_code?.unit;
            }
          });
      }
      if (!hsn_sac_code.unit) {
        newData &&
          newData?.map((item: any) => {
            if (item.column_name === "unit") {
              item.column_value = "";
            }

            return item;
          });
      }
      if (hsn_sac_code && hsn_sac_code.rate) {
        newData &&
          newData?.map((item: any) => {
            if (item.column_name === "rate") {
              item.column_value = hsn_sac_code?.rate;
            }
          });

        setCalculationDetails((prev: any) => ({
          ...prev,
          itemDetailsData: {
            ...prev.itemDetailsData,
            rate: hsn_sac_code?.rate,
          },
        }));
      }
      if (!hsn_sac_code.rate) {
        newData &&
          newData?.map((item: any) => {
            if (item.column_name === "rate") {
              item.column_value = "";
            }
            return item;
          });

        setCalculationDetails((prev: any) => ({
          ...prev,
          itemDetailsData: {
            ...prev.itemDetailsData,
            rate: "",
            quantity: "",
            amount: "",
            cgst_amount: "",
            discount: "",
            gst_percentage: "",
            igst_amount: "",
            sgst_amount: "",
            taxable_value: "",
            total_value: "",
          },
        }));
      }
      if (!hsn_sac_code.data) {
        newData &&
          newData?.map((item: any) => {
            if (item.column_name === "hsn_sac_code") {
              item.column_value = "";
            }

            return item;
          });
      }
    }

    setItemDataTemp(newData);
  };

  const handlePaymentData = (
    value: any,
    name: string,
    index: number,
    subType: string,
    rIdx?: number,
    rowIndex?: number
  ) => {
    if (subType === "payment" && rIdx !== undefined) {
      let newData = JSON.parse(JSON.stringify(paymentData));
      let temp = newData[rIdx][index];
      temp.column_value = handleDate(value);
      newData[rIdx][index] = temp;
      setPaymentData(newData);

      if (
        rowIndex != undefined &&
        paymentIndex.includes(rowIndex) === false &&
        (temp?.column_name === "net_payment_made" ||
          temp?.column_name === "mode_of_payment" ||
          temp?.column_name === "dop_in_bank_cash" ||
          temp?.column_name === "net_amount_received" ||
          temp?.column_name === "mode_of_receipts" ||
          temp?.column_name === "dor_in_bank_cash")
      ) {
        if (
          (temp?.column_name === "net_payment_made" && temp?.column_value) ||
          (temp?.column_name === "mode_of_payment" && temp?.column_value) ||
          (temp?.column_name === "dop_in_bank_cash" && temp?.column_value) ||
          (temp?.column_name === "net_amount_received" && temp?.column_value) ||
          (temp?.column_name === "mode_of_receipts" && temp?.column_value) ||
          (temp?.column_name === "dor_in_bank_cash" && temp?.column_value)
        ) {
          setPaymentIndex([...paymentIndex, rowIndex]);
        }
      } else {
        let columnArray: any[] = [];

        if (
          newData[rIdx][0]?.column_name === "net_payment_made" &&
          !newData[rIdx][0]?.column_value
        ) {
          columnArray.push(1);
        }
        if (
          newData[rIdx][1]?.column_name === "mode_of_payment" &&
          !newData[rIdx][1]?.column_value
        ) {
          columnArray.push(1);
        }
        if (
          newData[rIdx][2]?.column_name === "dop_in_bank_cash" &&
          !newData[rIdx][2]?.column_value
        ) {
          columnArray.push(1);
        }

        //revenues
        if (
          newData[rIdx][0]?.column_name === "net_amount_received" &&
          !newData[rIdx][0]?.column_value
        ) {
          columnArray.push(1);
        }
        if (
          newData[rIdx][1]?.column_name === "mode_of_receipts" &&
          !newData[rIdx][1]?.column_value
        ) {
          columnArray.push(1);
        }
        if (
          newData[rIdx][2]?.column_name === "dor_in_bank_cash" &&
          newData[rIdx][2]?.sequence === 4 &&
          !newData[rIdx][2]?.column_value
        ) {
          columnArray.push(1);
        }
        if (
          newData[rIdx][3]?.column_name === "dor_in_bank_cash" &&
          newData[rIdx][3]?.sequence === 4 &&
          !newData[rIdx][3]?.column_value
        ) {
          columnArray.push(1);
        }

        if (columnArray?.length === 3 && rowIndex != undefined) {
          setPaymentIndex([...paymentIndex.filter((el) => el != rowIndex)]);
          paymentErrorCount[rowIndex] = [];
          setPaymentErrorCount([...paymentErrorCount]);
        }
      }
      if (rowIndex != undefined) {
        if (
          paymentErrorCount?.length > 0 &&
          paymentErrorCount[rowIndex]?.length > 0
        ) {
          let findIndex = paymentErrorCount[rowIndex]?.find(
            (a: any) => a == index
          );
          let filterArray = paymentErrorCount[rowIndex]?.filter(
            (el: number) => el != findIndex
          );
          paymentErrorCount[rowIndex] = filterArray;
          setPaymentErrorCount && setPaymentErrorCount([...paymentErrorCount]);
        }
      }
    }
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const getImageDetails = (data: any) => {
    setImageDetails({
      fileUrl: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };

  const resetImageUrl = () => {
    setImageDetails({
      fileUrl: "",
      fileType: "",
      finalFileName: "",
    });
  };

  const saveItemData = () => {
    setTdsTcsValue({ label: "Select..", value: null, id: 0, section_name: "" });
    setTcsTdsData({ type: "", id: 0, amount: 0, rate: 0, section_name: "" });
    setTds(0);
    setTcs(0);
    let validate;
    let temp = JSON.parse(JSON.stringify(itemDataTemp));
    let idm = JSON.parse(JSON.stringify(itemData));
    temp = temp.map((e: any) => {
      if (e.column_name === "batch_number") {
        return { ...e, batchOptions: mappedBatch };
      } else {
        return e;
      }
    });

    validate = validateItem(validate, temp);

    if (!validate)
      return toast.error("Please fill all the mandatory values", {
        duration: 3500,
      });

    idm[`new-${newCount}`] = temp;
    setNewCount(newCount + 1);
    setItemData(idm);
    setItemDataTemp(itemCol);
    setShowAddModal(false);
    setCalculationDetails((prev: any) => ({ ...prev, itemDetailsData: {} }));
    setIsSkuCode(false);
  };

  const editItemData = () => {
    setTdsTcsValue({
      label: "Select..",
      value: null,
      id: 0,
      section_name: "",
    });
    setTcsTdsData({ type: "", id: 0, amount: 0, rate: 0, section_name: "" });
    setTds(0);
    setTcs(0);
    let validate;
    let temp = JSON.parse(JSON.stringify(itemDataTemp));
    let idm = JSON.parse(JSON.stringify(itemData));
    temp = temp.map((e: any) => {
      if (e.column_name === "batch_number") {
        return { ...e, batchOptions: mappedBatch };
      } else {
        return e;
      }
    });
    if (editItemIndex !== null) {
      idm[editItemIndex] = temp;
    }

    validate = validateItem(validate, temp);

    if (!validate)
      return toast.error("Please fill all the mandatory values", {
        duration: 3500,
      });

    setItemData(idm);
    setItemDataTemp(itemCol);
    setEditItemIndex(null);
    toggleModal();
    setCalculationDetails((prev: any) => ({ ...prev, itemDetailsData: {} }));
    setIsSkuCode(false);
  };

  const handleAddNewPayment = () => {
    const temp = JSON.parse(JSON.stringify(paymentData));
    if (type === "revenues") {
      temp[`new-${newCount + 1}`] = revPaymentCol;
    } else {
      temp[`new-${newCount + 1}`] = paymentCol;
    }

    setNewCount(newCount + 1);
    setPaymentData(temp);
  };

  const removeDuplicate = (data: any) => {
    let nonRepeatData: any = new Set();

    data?.forEach(
      (obj: any) =>
        !nonRepeatData.has(JSON.stringify(obj)) &&
        nonRepeatData.add(JSON.stringify(obj))
    );

    let finalData: any = new Set(
      [...nonRepeatData].map((item) => JSON.parse(item))
    );
    return finalData;
  };

  const handleUploadFile = (data: any) => {
    setShowFileUploadModal(false);
    let newFileUploadData: any = JSON.parse(JSON.stringify(uploadData));
    setUploadData({ ...newFileUploadData, column_value: data });
  };

  const handleToggleFileUploadModal = () => {
    setShowFileUploadModal(!showFileUploadModal);
  };

  const renderFilesList = () => {
    const isDelete = true;
    const finalFileList =
      uploadData?.column_value?.length > 0 &&
      uploadData?.column_value?.map((data: any, index: number) => {
        let file_type = data.file_url.split(".");
        return file_type[file_type.length - 1].toLowerCase() === "png" ||
          file_type[file_type.length - 1].toLowerCase() === "jpg" ||
          file_type[file_type.length - 1].toLowerCase() === "jpeg" ||
          file_type[file_type.length - 1].toLowerCase() === "doc" ||
          file_type[file_type.length - 1].toLowerCase() === "docx" ||
          file_type[file_type.length - 1].toLowerCase() === "xls" ||
          file_type[file_type.length - 1].toLowerCase() === "xlsx" ||
          file_type[file_type.length - 1].toLowerCase() === "pdf"
          ? imagePreview(
              data,
              index,
              getImageDetails,
              handleEditFileList,
              setShowPopUpContentModal,
              isDelete
            )
          : downloadLink(
              data,
              index,
              getImageDetails,
              handleEditFileList,
              setShowPopUpContentModal,
              isDelete
            );
      });

    return finalFileList;
  };

  const handleEditFileList = (index: number) => {
    setShowPopUpContentModal(false);
    const tempFileData = JSON.parse(JSON.stringify(uploadData));

    const isFilePresent = tempFileData?.column_value?.find(
      (data: any, idx: number) => {
        return idx === index;
      }
    );

    if (!!isFilePresent) {
      let temp = tempFileData?.column_value;
      let newData = temp?.filter((data: any, idx: number) => idx !== index);
      tempFileData.column_value = newData;
      setUploadData(tempFileData);
    }
  };

  const primaryDetails = () => {
    let newPrimaryData = primaryData?.find(
      (item: any) => item?.column_name === "voucher_invoice_date"
    );
    let splitedInvoiceDate = newPrimaryData?.column_value?.split("-");
    let finalPrimaryData = JSON.parse(JSON.stringify(primaryData));
    if (splitedInvoiceDate?.length && splitedInvoiceDate[0]?.length < 4) {
      let newData = finalPrimaryData?.map((item: any) => {
        if (item?.column_name === "voucher_invoice_date") {
          let newDate = splitedInvoiceDate?.reverse()?.join("-");
          return { ...item, column_value: newDate };
        } else {
          return item;
        }
      });
      finalPrimaryData = newData;
    }

    return (
      <>
        <h4> Invoice Details</h4>
        <div className="row">
          {finalPrimaryData &&
            finalPrimaryData.length &&
            finalPrimaryData?.map((value: any, index: number) => {
              if (value.column_name !== "ship_to_gst") {
                if (value.column_name !== "ship_to_address") {
                  if (value.column_name !== "ship_to_name") {
                    return (
                      <>
                        {value?.column_name !== "mapping_tax_invoice" ? (
                          <Col xs="3">
                            <SingleInput
                              item={value}
                              callback={handlePrimaryData}
                              // handleUpload={this.handleUpload}
                              // handleRemoveUpload={this.handleRemoveUpload}
                              selectOption={selectOption}
                              updateUppliersAddress={updateUppliersAddress}
                              index={index}
                              subType="primary"
                              client_code={client_code}
                              limit={limit}
                              offset={offset}
                              customerSupplierListTotalData={
                                customerSupplierListTotalData
                              }
                              setOffset={setOffset}
                              setText={setText}
                              text={text}
                              isLoading={clientSettingsFetching}
                              isAddCustomerSupplierPresent={
                                isAddCustomerSupplierPresent
                              }
                              handleToggleAddCustomerSupplierModal={
                                handleToggleAddCustomerSupplierModal
                              }
                              calculationDetails={calculationDetails}
                              setConvert={setConvert}
                              currentDocumentValue={currentDocumentValue}
                              isTypeChange={isTypeChange}
                              setIsTypeChange={setIsTypeChange}
                              confirmChangeType={confirmChangeType}
                              setConfirmChangeType={setConfirmChangeType}
                              onCancel={onCancel}
                              setNewDocumentType={setNewDocumentType}
                              singleInvoiceDetails={singleInvoiceDetails}
                              newDocumentType={newDocumentType}
                              setDoucumentPreviosValue={
                                setDoucumentPreviosValue
                              }
                              doucumentPreviosValue={doucumentPreviosValue}
                              storeDocumentType={storeDocumentType}
                              setStoreDocumentType={setStoreDocumentType}
                              setPlaceOfSupply={setPlaceOfSupply}
                              placeOfSupply={placeOfSupply}
                              auditSeasonMessage={auditSeasonMessage}
                              primaryData={primaryData}
                              setCurrencyText={setCurrencyText}
                              currencyExchangeDetails={currencyExchangeDetails}
                              currencyExchangeSuccess={currencyExchangeSuccess}
                              currencyExchangeError={currencyExchangeError}
                              dispatchResetMasterError={
                                dispatchResetMasterError
                              }
                              clientCurrencyShortForm={clientCurrencyShortForm}
                              currencySign={currencySign}
                              clientCurrencyName={clientCurrencyName}
                            />
                          </Col>
                        ) : (((currentDocumentValue?.column_value?.value ===
                            "debit_note" ||
                            currentDocumentValue?.column_value?.value ===
                              "credit_note") &&
                            newDocumentType === "" &&
                            !isTypeChange) ||
                            newDocumentType === "Debit Note" ||
                            newDocumentType === "Credit Note") &&
                          value?.column_name === "mapping_tax_invoice" &&
                          !isTypeChange ? (
                          <Col xs="3">
                            <SingleInput
                              item={value}
                              callback={handlePrimaryData}
                              // handleUpload={this.handleUpload}
                              // handleRemoveUpload={this.handleRemoveUpload}
                              selectOption={selectOption}
                              updateUppliersAddress={updateUppliersAddress}
                              index={index}
                              subType="primary"
                              client_code={client_code}
                              limit={limit}
                              offset={offset}
                              customerSupplierListTotalData={
                                customerSupplierListTotalData
                              }
                              setOffset={setOffset}
                              setText={setText}
                              text={text}
                              isLoading={clientSettingsFetching}
                              isAddCustomerSupplierPresent={
                                isAddCustomerSupplierPresent
                              }
                              handleToggleAddCustomerSupplierModal={
                                handleToggleAddCustomerSupplierModal
                              }
                              calculationDetails={calculationDetails}
                              setConvert={setConvert}
                              currentDocumentValue={currentDocumentValue}
                              isTypeChange={isTypeChange}
                              setIsTypeChange={setIsTypeChange}
                              confirmChangeType={confirmChangeType}
                              setConfirmChangeType={setConfirmChangeType}
                              onCancel={onCancel}
                              setNewDocumentType={setNewDocumentType}
                              singleInvoiceDetails={singleInvoiceDetails}
                              newDocumentType={newDocumentType}
                              setDoucumentPreviosValue={
                                setDoucumentPreviosValue
                              }
                              doucumentPreviosValue={doucumentPreviosValue}
                              storeDocumentType={storeDocumentType}
                              setStoreDocumentType={setStoreDocumentType}
                              setPlaceOfSupply={setPlaceOfSupply}
                              placeOfSupply={placeOfSupply}
                              auditSeasonMessage={auditSeasonMessage}
                              setCurrencyText={setCurrencyText}
                              currencyExchangeDetails={currencyExchangeDetails}
                              currencyExchangeSuccess={currencyExchangeSuccess}
                              currencyExchangeError={currencyExchangeError}
                              dispatchResetMasterError={
                                dispatchResetMasterError
                              }
                              clientCurrencyShortForm={clientCurrencyShortForm}
                              currencySign={currencySign}
                              clientCurrencyName={clientCurrencyName}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                      </>
                    );
                  }
                }
              }
            })}
        </div>

        {uploadData?.column_value?.length &&
        uploadData?.column_value?.length > 0 ? (
          <div className="pointer">
            <span id="Popover1">
              <PaperClipIcon />
              <span className="badge count-badge">
                {uploadData?.column_value?.length &&
                uploadData?.column_value?.length > 0
                  ? uploadData?.column_value?.length
                  : ""}
              </span>
            </span>
          </div>
        ) : (
          ""
        )}
        <button
          className="btn btn-sm btn-outline mt-3"
          onClick={handleToggleFileUploadModal}
        >
          <span>
            <UploadNew /> Upload Files
          </span>
        </button>

        <div>
          {renderUploadedFiles(
            showPopUpContentModal,
            setShowPopUpContentModal,
            renderFilesList
          )}
        </div>
        <hr />

        {singleCustomerSupplier &&
          Array.isArray(singleCustomerSupplier?.shipping_addresses) &&
          singleCustomerSupplier?.shipping_addresses?.length > 0 &&
          isShippingColumnsAssigned && (
            <>
              <ShippingAddressTab
                RADIO_OPTIONS={RADIO_OPTIONS}
                handleSetRadioValue={handleSetRadioValue}
                isShippingAddressVisible={isShippingAddressVisible}
              />
              {isShippingAddressVisible == "1" && (
                <div className="row">
                  {shippingAddressColumns?.map((value: any, index: number) => {
                    return (
                      <Col xs="3">
                        <SingleInput
                          item={value}
                          callback={handlePrimaryData}
                          selectOption={selectOption}
                          isAddCustomerSupplierPresent={
                            isAddCustomerSupplierPresent
                          }
                          updateUppliersAddress={updateUppliersAddress}
                          index={index}
                          subType="primary"
                          client_code={client_code}
                          handleToggleAddCustomerSupplierModal={
                            handleToggleAddCustomerSupplierModal
                          }
                          limit={limit}
                          setOffset={setOffset}
                          setText={setText}
                          text={text}
                          isLoading={clientSettingsFetching}
                          customerSupplierListTotalData={
                            customerSupplierListTotalData
                          }
                          offset={offset}
                          clearShippingColumn={clearShippingColumn}
                          isShippingAddressVisible={isShippingAddressVisible}
                          currencyExchangeDetails={currencyExchangeDetails}
                          setCurrencyText={setCurrencyText}
                          currencyExchangeSuccess={currencyExchangeSuccess}
                          currencyExchangeError={currencyExchangeError}
                          dispatchResetMasterError={dispatchResetMasterError}
                          clientCurrencyShortForm={clientCurrencyShortForm}
                          currencySign={currencySign}
                          clientCurrencyName={clientCurrencyName}
                        />
                      </Col>
                    );
                  })}
                </div>
              )}
            </>
          )}

        <Row className="d-none">
          <Col xs="12" className="text-right">
            <span className="text-link mr-2">Exit without saving</span>
            <Button>Save and Next</Button>
          </Col>
        </Row>
      </>
    );
  };

  const addNewRecord = () => {
    dispatchResetMappedStockBatchList();
    setMappedBatch([]);
    setShowAddModal(true);
    setItemDataTemp(itemCol);
  };

  const [finalHeader, setFinalHeader] = useState<any[]>([]);
  useEffect(() => {
    let finalHeader: any[] = [];
    finalHeader.push(DOUBLE_ENTRY_ITEM_HEADER[0]);
    for (let i = 0; i < itemCol.length; i++) {
      for (let j = 0; j < DOUBLE_ENTRY_ITEM_HEADER.length; j++) {
        if (itemCol[i].column_name === DOUBLE_ENTRY_ITEM_HEADER[j].value) {
          finalHeader.push(DOUBLE_ENTRY_ITEM_HEADER[j]);
        }
      }
    }

    setFinalHeader(finalHeader);
  }, [itemCol]);

  const itemDetails = () => {
    return (
      <>
        <h4> Item Details</h4>
        {
          <ItemTable
            tableHeader={finalHeader}
            data={itemData}
            editEntry={handleEditItemList}
            totalValue={totalValue}
            setTds={setTds}
            tds={tds}
            deleteEntry={handleDeleteItemList}
            client_code={client_code}
            currencySign={currencySign}
            currencyExchangeDetails={currencyExchangeDetails}
            primaryData={primaryData}
            currencyExchangeError={currencyExchangeError}
            clientCurrencyShortForm={clientCurrencyShortForm}
            clientCurrencyName={clientCurrencyName}
          />
        }

        <div className="d-flex ">
          <Button
            className="mt-3"
            style={{ height: "fit-content", whiteSpace: "nowrap" }}
            onClick={() => {
              const placeOfSupplyArray: any[] = primaryData?.filter(
                (el) => el?.column_name == "place_of_supply"
              );
              if (placeOfSupplyArray?.length > 0) {
                if (
                  primaryData?.find(
                    (el: any) => el?.column_name === "currency"
                  ) &&
                  primaryData?.find((el: any) => el?.column_name === "currency")
                    ?.column_value?.currencyShortForm !== "INR" &&
                  primaryData
                    ?.find((el: any) => el?.column_name === "currency")
                    .hasOwnProperty("column_value")
                ) {
                  addNewRecord();
                } else if (
                  placeOfSupply === "filled" ||
                  placeOfSupplyArray[0]?.column_value
                ) {
                  addNewRecord();
                } else {
                  setPlaceOfSupply("Place of Supply Required");
                }
              } else {
                addNewRecord();
              }
            }}
          >
            {/* <IconPlusCircle /> */}
            Add New Record
          </Button>

          <TdsTcs
            data={itemData}
            totalValue={totalValue}
            setTds={setTds}
            setTcs={setTcs}
            taxableValueSum={taxableValueSum}
            tds={tds}
            tcs={tcs}
            client_code={client_code}
            currencySign={currencySign}
            currencyExchangeDetails={currencyExchangeDetails}
            primaryData={primaryData}
            currencyExchangeError={currencyExchangeError}
            clientCurrencyShortForm={clientCurrencyShortForm}
            clientCurrencyName={clientCurrencyName}
            setTcsTdsData={setTcsTdsData}
            singleInvoiceDetails={singleInvoiceDetails}
            setChangeTCSTDSRadioValue={setChangeTCSTDSRadioValue}
            changeTCSTDSRadioValue={changeTCSTDSRadioValue}
            setTdsTcsValue={setTdsTcsValue}
            tdsTcsvalue={tdsTcsvalue}
            tdstcsChanges={tdstcsChanges}
            setTdsChanges={setTdsChanges}
          />
        </div>
      </>
    );
  };

  const handleDeleteItemList = (index: number) => {
    setTdsTcsValue({
      label: "Select..",
      value: null,
      id: 0,
      section_name: "",
    });
    setTcsTdsData({
      type: "",
      id: 0,
      amount: 0,
      rate: 0,
      section_name: "",
    });
    setTdsChanges(true);
    setTds(0);
    setTcs(0);
    const temp = JSON.parse(JSON.stringify(itemData));

    if (temp[index]) delete temp[index];
    setItemData(temp);
  };

  const handleToggleOcrFileUploadModal = () => {
    setShowOcrFileUploadModal(!showOcrFileUploadModal);
  };

  const handleOcrUploadFile = (files: any) => {
    dispatchResetMultiFileUploadData();
    if (type && token && client_code) {
      let finalData: any = {
        token,
        client_code,
        invoice_id,
        type,
        file: files[0],
      };
      dispatchPostInvoiceOcrAction(finalData);

      if (token) {
        let finalSasData = {
          token,
          fileData: files[0],
          containerType: 5,
          clientCode: client_code,
        };
        dispatchUploadFilesAction(finalSasData);
      }
    }
    // if (!uploadData) {
    //   setUploadData([data]);
    // }
    // setShowFileUploadModal(false);
    // let oldFileUploadData = [...uploadData];
    // oldFileUploadData.push(data);
    // setUploadData(oldFileUploadData);
  };

  const handleEditItemList = (index: number) => {
    singleInvoiceDetails?.invoice_data?.primary?.map((item: any) => {
      if (item.column_name === "bill_from") {
        setCalculationDetails((prev: any) => ({
          ...prev,
          itemDetailsData: {
            ...prev.itemDetailsData,
            [item.column_name]: { state: item.column_value?.state },
          },
        }));
      }
      if (item.column_name === "supplier_name") {
        setCalculationDetails((prev: any) => ({
          ...prev,
          itemDetailsData: {
            ...prev.itemDetailsData,
            [item.column_name]: { state: item.column_value?.state },
          },
        }));
      }
      if (item.column_name === "place_of_supply") {
        setCalculationDetails((prev: any) => ({
          ...prev,
          itemDetailsData: {
            ...prev.itemDetailsData,
            [item.column_name]: { value: item.column_value },
          },
        }));
      }
    });
    setEditItemIndex(index);
    let editItem = JSON.parse(JSON.stringify(itemData));

    let updateItem = editItem[index]?.map((item: any, i: number) => {
      setCalculationDetails((prev: any) => ({
        ...prev,
        itemDetailsData: {
          ...prev.itemDetailsData,
          [item.column_name]: item.column_value,
        },
      }));
      if (item.column_name === "sku_code" && item.column_value) {
        setIsSkuCode(true);

        if (item.column_name === "sku_code" && item.column_value) {
          let finalData = {
            token,
            clientCode: client_code,
            stockId: item.column_value?.value,
            isEnable: 1,
          };
          dispatchGetStockMappedBatchListAction(finalData);
        }
      }
      if (item.column_name === "nature_of_expense") {
        let temp = { ...item };
        temp["value"] = item.column_value?.ledger_id;
        temp["label"] = item.column_value?.ledger_name;
        item = temp;
        return item;
      }
      if (item.column_name === "sku_code") {
        let temp = { ...item };
        temp["value"] = item.column_value?.ledger_id;
        temp["label"] = item.column_value?.ledger_name;
        item = temp;
        return item;
      }
      if (item.column_name === "nature_of_income") {
        let temp = { ...item };
        temp["value"] = item.column_value?.ledger_id;
        temp["label"] = item.column_value?.ledger_name;
        item = temp;
        return item;
      }

      return item;
    });

    resettingGstOnEdit(calculationDetails, updateItem, type);
    setItemDataTemp([...updateItem]);
    toggleModal();
  };

  const handleDeletePayment = (key: number, rIdx: number) => {
    const temp = JSON.parse(JSON.stringify(paymentData));
    if (temp[key]) delete temp[key];
    setPaymentData(temp);
    paymentIndex.splice(rIdx, 1);
    setPaymentIndex([...paymentIndex]);
    paymentErrorCount.splice(rIdx, 1);
    setPaymentErrorCount([...paymentErrorCount]);
  };

  const validateItem = (validate: boolean = true, data: any) => {
    let isValid = validate;
    data &&
      data?.map((item: any) => {
        if (
          item?.column_name === "nature_of_income" ||
          item?.column_name === "nature_of_expense" ||
          item?.column_name === "description_as_per_bill" ||
          item?.column_name === "total_value" ||
          (isSkuCode && item?.column_name === "rate") ||
          (isSkuCode && item?.column_name === "quantity")
        ) {
          if (
            !item.hasOwnProperty("column_value") ||
            item?.column_value === "" ||
            item?.column_value === 0 ||
            !item?.column_value ||
            (item?.column_name === "nature_of_income" &&
              !item?.column_value?.ledger_id)
          ) {
            isValid = false;
          }
        }
      });

    return isValid;
  };

  //check compulsory field value
  const validateSubmitData = (itemT: any, primaryT: any, paymentT: any) => {
    let validate = true;

    let idm = JSON.parse(JSON.stringify(itemData));

    for (let key in idm) {
      idm[key]?.map((temp: any) => {
        validate = validateItem(validate, idm[key]);
        if (!validate) return (validate = false);
      });
    }

    if (Object.keys(itemData).length === 0 || primaryData.length === 0)
      return false;

    for (let key in primaryData) {
      if (
        primaryData[key]?.column_name === "branch" ||
        primaryData[key]?.column_name === "voucher_invoice_date" ||
        primaryData[key]?.column_name === "supplier_name" ||
        primaryData[key]?.column_name === "bill_from" ||
        primaryData[key]?.column_name === "customer_name" ||
        (primaryData[key]?.column_name === "place_of_supply"
          ? primaryData[key]?.column_name === "place_of_supply" &&
            primaryData?.find((el: any) => el?.column_name === "currency")
              ?.column_value?.currencyShortForm === "INR"
          : primaryData[key]?.column_name === "place_of_supply") ||
        primaryData[key]?.column_name === "ship_to_name"
      ) {
        if (
          primaryData[key]?.column_name === "ship_to_name" &&
          isShippingAddressVisible === "1"
        ) {
          if (primaryData[key]?.column_value === "") {
            validate = false;
          }
        }
        if (
          !!currencyExchangeError?.length &&
          currencyExchangeError?.includes("list not found") &&
          currencyExchangeSuccess === 0
        ) {
          validate = false;
        }
        if (
          (primaryData[key]?.column_name !== "ship_to_name" &&
            !primaryData[key].hasOwnProperty("column_value")) ||
          (primaryData[key]?.column_name !== "ship_to_name" &&
            primaryData[key]?.column_value === "") ||
          (primaryData[key]?.column_name !== "ship_to_name" &&
            primaryData[key]?.column_value === null)
        ) {
          validate = false;
        }
      }
    }

    itemData &&
      Object.keys(itemData) &&
      Object.keys(itemData)?.map((item: any) => {
        for (let key in itemData[item]) {
          if (
            itemData[item][key]?.column_name === "nature_of_income" ||
            itemData[item][key]?.column_name === "nature_of_expense" ||
            itemData[item][key]?.column_name === "description_as_per_bill" ||
            itemData[item][key]?.column_name === "total_value" ||
            (isSkuCode && itemData[item][key]?.column_name === "rate") ||
            (isSkuCode && itemData[item][key]?.column_name === "quantity")
          ) {
            if (
              !itemData[item][key].hasOwnProperty("column_value") ||
              itemData[item][key]?.column_value === "" ||
              ((itemData[item][key]?.column_name === "nature_of_income" ||
                itemData[item][key]?.column_name === "nature_of_expense") &&
                !itemData[item][key]?.column_value?.ledger_id)
            ) {
              validate = false;
            }
          }
        }
      });
    return validate;
  };

  const validate = (): void => {
    let validate = validateSubmitData(item, primary, payment);

    if (validate === false) {
      toast.error("Please fill all the mandatory values", {
        duration: 3500,
      });
    }
  };

  const checkDuplicateEntryFunction = () => {
    let voucherInvoiceNumber = primaryData.find(
      (e: any) => e.name === "Voucher/Invoice Number"
    );
    let dateOfInvoice = primaryData.find(
      (e: any) => e.name === "Voucher/Invoice Date"
    );
    let supplierId = primaryData.find((e: any) => e.name === "Supplier Name");
    let payload = {
      client_code,
      token,
      type,
      voucher_invoice_number: voucherInvoiceNumber?.column_value?.trim(),
      date_of_invoice:
        dateOfInvoice === "Invalid date" || dateOfInvoice === ""
          ? ""
          : moment(dateOfInvoice?.column_value).format("DD-MM-YYYY"),
      supplier_id: supplierId?.column_value.ledger_id,
      operation: "add",
    };

    dispatchCheckDuplicateEntryAction(payload);
  };

  const handleSubmit = () => {
    dispatchResetIsDuplicateInvoice();
    let itemT = JSON.parse(JSON.stringify(itemData));
    const primaryT = JSON.parse(JSON.stringify(primaryData));
    let paymentT = JSON.parse(JSON.stringify(paymentData));

    checkPaymentError(paymentT);

    let payload: any = {};
    itemT &&
      Object.keys(itemT)?.map((index: any) => {
        index &&
          itemT[index] &&
          itemT[index].map((data: any) => {
            if (!data.hasOwnProperty("column_value")) {
              return (data["column_value"] = "");
            }
            if (
              item["column_name"] === "department" &&
              (Object.keys(item["column_value"])?.length === 0 ||
                item["column_value"] === "")
            ) {
              return (item["column_value"] = null);
            }
          });
      });

    primaryT?.map((item: any) => {
      if (item["data_type"] === "date" && item["column_value"]) {
        // eslint-disable-next-line
        item["column_value"] = item["column_value"];

        return item;
      }
      if (
        type === "expenses" &&
        item["column_value"]?.value === "purchase_order"
      ) {
        payload["invoice_category"] = 2;
      }
      if (type === "revenues" && item["column_value"]?.value === "estimation") {
        payload["invoice_category"] = 2;
      }

      if (item["column_name"] === "document_type" && !item["column_value"]) {
        item["column_value"] = { value: "tax_invoice", label: "Tax Invoice" };
      }
      if (
        item.column_name === "upload" &&
        uploadData &&
        uploadData?.column_value?.length > 0
      ) {
        item["column_value"] = uploadData?.column_value;

        return item;
      }
      if (item.column_name === "mapping_tax_invoice" && !item["column_value"]) {
        item["column_value"] = {};
      }
      if (item.column_name === "mapping_tax_invoice" && item["column_value"]) {
        // eslint-disable-next-line
        item["column_value"] = item["column_value"];
      } else if (!item.hasOwnProperty("column_value")) {
        return (item["column_value"] = "");
      }
    });

    paymentT &&
      Object.values(paymentT)?.map((data: any) => {
        return (
          data &&
          data?.map((item: any) => {
            if (item["data_type"] === "date" && item["column_value"]) {
              // eslint-disable-next-line
              item["column_value"] = item["column_value"];
              return item["column_value"];
            }

            if (
              !item.hasOwnProperty("column_value") ||
              item["column_value"] === null
            ) {
              return (item["column_value"] = "");
            }
          })
        );
      });

    // /
    let finalArray: any = [];
    type == "expenses" &&
      paymentT &&
      Object.values(paymentT)?.map((data: any, index: number) => {
        let rIdxArray: number[] = [];

        if (data[0]?.column_value) {
          if (!data[1].column_value) {
            rIdxArray.push(1);
          }
          if (!data[2].column_value) {
            rIdxArray.push(2);
          }
        }

        if (data[1]?.column_value) {
          if (!data[0].column_value) {
            rIdxArray.push(0);
          }
          if (!data[2].column_value) {
            rIdxArray.push(2);
          }
        }

        if (data[2]?.column_value) {
          if (!data[0].column_value) {
            rIdxArray.push(0);
          }
          if (!data[1].column_value) {
            rIdxArray.push(1);
          }
        }

        finalArray.push(rIdxArray);
      });

    type == "revenues" &&
      paymentT &&
      Object.values(paymentT)?.map((data: any, index: number) => {
        let rIdxArray: number[] = [];

        if (data[0]?.column_value) {
          if (!data[1].column_value) {
            rIdxArray.push(1);
          }
          if (!data[2].column_value && data[2]?.sequence === 4) {
            rIdxArray.push(2);
          }
          if (!data[3].column_value && data[3]?.sequence === 4) {
            rIdxArray.push(3);
          }
        }
        if (data[1]?.column_value) {
          if (!data[0].column_value) {
            rIdxArray.push(0);
          }
          if (!data[2].column_value && data[2]?.sequence === 4) {
            rIdxArray.push(2);
          }
          if (!data[3].column_value && data[3]?.sequence === 4) {
            rIdxArray.push(3);
          }
        }
        if (data[2]?.column_value && data[2]?.sequence === 4) {
          if (!data[0].column_value) {
            rIdxArray.push(0);
          }
          if (!data[1].column_value) {
            rIdxArray.push(1);
          }
        }
        if (data[3]?.column_value && data[3]?.sequence === 4) {
          if (!data[0].column_value) {
            rIdxArray.push(0);
          }
          if (!data[1].column_value && data[1]?.sequence === 2) {
            rIdxArray.push(1);
          }
        }

        finalArray.push(rIdxArray);
      });

    setPaymentErrorCount([...finalArray]);

    setItemData(itemT);
    setPrimaryData(primaryT);
    setPaymentData(paymentT);
    itemT = Object.values(itemT);
    paymentT = Object.values(paymentT);

    let paymentFiled = true;
    finalArray.map((el: number[]) => {
      if (el?.length > 0) {
        paymentFiled = false;
      }
    });

    let validate =
      paymentFiled && validateSubmitData(itemT, primaryT, paymentT);

    if (validate === false) {
      toast.error("Please fill all the mandatory values", {
        duration: 3500,
      });

      return false;
    }

    const finalObj: any = {
      item: itemT,
      primary: primaryT,
      payment: paymentT,
    };
    let voucherInvoiceDate = primaryData?.find(
      (e: any) => e.name === "Voucher/Invoice Date"
    );
    finalObj["invoice_value"] = totalValue;
    finalObj["tds"] = tds;
    finalObj["tds_tcs_details"] = tcsTdsData;
    finalObj["net_amount"] =
      changeTCSTDSRadioValue === "TDS" ? totalValue - tds : totalValue + tcs;
    payload["invoice_date"] = voucherInvoiceDate?.column_value;
    payload["token"] = token;
    payload["type"] = type;
    payload["client_code"] = client_code;
    payload["invoice_data"] = finalObj;
    payload["is_invoice_ocr_created"] = 1;
    payload["rate"] = currencyExchangeDetails?.rate
      ? currencyExchangeDetails?.rate
      : 1;
    if (payload?.invoice_category === undefined) {
      payload["invoice_category"] = 1;
    }

    payload?.invoice_data?.primary?.forEach((e: any) => {
      if (e.name === "Voucher/Invoice Number") {
        return (e.column_value = e.column_value.trim());
      }
    });

    let voucherInvoiceNumber = primaryData?.find(
      (e: any) => e.name === "Voucher/Invoice Number"
    );
    if (type == "expenses") {
      payload["is_invoice_gstr2a2b_created"] = 0;
    }
    if (!voucherInvoiceNumber?.column_value) {
      dispatchAddInvoiceGenerationAction(payload);
    } else {
      setIsCheckDuplicatePayload(payload);
      checkDuplicateEntryFunction();
    }
  };

  const checkPaymentError = (payment: any) => {
    let allPaymentData = Object.values(payment);
    let finalArray: any = [];
    allPaymentData?.map((data: any, index: number) => {
      let rIdxArray: number[] = [];

      if (data[0]?.column_value) {
        if (!data[1].column_value) {
          rIdxArray.push(1);
        }
        if (!data[2].column_value) {
          rIdxArray.push(2);
        }
      }
      if (data[2]?.column_value) {
        if (!data[0].column_value) {
          rIdxArray.push(0);
        }
        if (!data[1].column_value) {
          rIdxArray.push(1);
        }
      }

      if (data[1]?.column_value) {
        if (!data[0].column_value) {
          rIdxArray.push(0);
        }
        if (!data[2].column_value) {
          rIdxArray.push(2);
        }
      }
      finalArray.push(rIdxArray);
    });
    setPaymentErrorCount([...finalArray]);
  };

  const paymentDetails = () => {
    const paymentDataT = JSON.parse(JSON.stringify(paymentData));
    let keys = Object.keys(paymentDataT);

    return (
      <>
        <h4> Payment Details</h4>
        {newDocumentType === "Credit Note" ? null : (
          <Row>
            <Col xs="11">
              <Button onClick={() => handleAddNewPayment()}>
                Add new Payment
              </Button>
            </Col>
          </Row>
        )}

        {keys &&
          keys?.map((key: any, rIdx: number) => {
            let allocationId = paymentDataT[key]?.find(
              (item: any) => item.column_name === "allocation_id"
            );
            if (!!allocationId?.column_value) {
              paymentDataT[key]?.length && delete paymentDataT[key];
            }
            return (
              <>
                <div className="d-flex align-items-center">
                  {paymentDataT &&
                    paymentDataT[key] &&
                    paymentDataT[key]?.length &&
                    paymentDataT[key]?.map((value: any, index: number) => {
                      let newValue = {
                        ...value,
                        isDisabled:
                          newDocumentType === "Credit Note" ? true : false,
                      };
                      return (
                        <>
                          <div className="mr-2 position-relative">
                            <SingleInput
                              item={newValue}
                              callback={handlePaymentData}
                              selectOption={selectOption}
                              index={index}
                              subType="payment"
                              rIdx={key}
                              client_code={client_code}
                              handleToggleAddCustomerSupplierModal={
                                handleToggleAddCustomerSupplierModal
                              }
                              calculationDetails={calculationDetails}
                              paymentIndex={paymentIndex}
                              paymentErrorCount={paymentErrorCount}
                              setPaymentErrorCount={setPaymentErrorCount}
                              rowIndex={rIdx}
                              clientCurrencyShortForm={clientCurrencyShortForm}
                              currencySign={currencySign}
                              clientCurrencyName={clientCurrencyName}
                            />
                          </div>
                        </>
                      );
                    })}

                  {(paymentDataT && paymentDataT[key]?.length === 1) ||
                  newDocumentType !== "Credit Note" ? (
                    <div
                      className="pointer"
                      onClick={() => handleDeletePayment(key, rIdx)}
                    >
                      <IconDelete />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </>
            );
          })}
      </>
    );
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSessionAction()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetUpdateInvoiceGenerationError();
            }}
          />
        );
      }
    }
    if (approvalSuccess === 1) {
      dispatchResetApprovalSuccess();
      toast.success("Approved Successfully!", {
        duration: 2000,
      });
      if (type && invoice_id && token && client_code) {
        let finalData: any = {
          token,
          client_code,
          invoice_id,
          type,
        };
        dispatchGetSingleInvoiceDetailsAction(finalData);
      }
    }
    if (commentsSuccess === 1) {
      dispatchResetCommentsSuccess();
      toast.success("Comment Added Successfully!", {
        duration: 2000,
      });
      if (type && invoice_id && token && client_code) {
        let finalData: GetCommentPayloadType = {
          type,
          token,
          invoice_id,
          client_code,
        };
        dispatchGetAllInvoiceCommentsAction(finalData);
      }
    }
    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={"Invoice Added Successfully!"}
          buttonText="OK"
          onPress={() => {
            dispatchResetUpdateInvoiceGenerationSuccess();
            handleGoBack();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };

  const renderItemInput = () => {
    if (
      typeof itemDataTemp === "object" &&
      !Array.isArray(itemDataTemp) &&
      itemDataTemp !== null
    ) {
      return Object.keys(itemDataTemp)?.map((newKey: string, index: number) => {
        return (
          <>
            {itemDataTemp[newKey] &&
              itemDataTemp[newKey] &&
              Array.isArray(itemDataTemp[newKey]) &&
              itemDataTemp[newKey]?.map((value: any) => (
                <Col
                  xs={
                    value?.column_name === "description_as_per_bill" ? "6" : "3"
                  }
                >
                  <SingleInput
                    item={value}
                    callback={handleItemData}
                    selectOption={selectOption}
                    index={index}
                    subType="item"
                    setIsSkuCode={setIsSkuCode}
                    isSkuCode={isSkuCode}
                    editItemIndex={editItemIndex}
                    client_code={client_code}
                    isAddCustomerSupplierPresent={isAddCustomerSupplierPresent}
                    handleToggleAddCustomerSupplierModal={
                      handleToggleAddCustomerSupplierModal
                    }
                    calculationDetails={calculationDetails}
                    currencyExchangeDetails={currencyExchangeDetails}
                    clientCurrencyShortForm={clientCurrencyShortForm}
                    currencySign={currencySign}
                    clientCurrencyName={clientCurrencyName}
                    setSelectedSkuId={setSelectedSkuId}
                    selectedSkuId={selectedSkuId}
                  />
                </Col>
              ))}
          </>
        );
      });
    } else {
      return (
        itemDataTemp &&
        itemDataTemp?.map((value: any, index: number) => {
          return (
            <Col
              xs={value?.column_name === "description_as_per_bill" ? "6" : "3"}
            >
              <SingleInput
                item={value}
                callback={handleItemData}
                selectOption={selectOption}
                index={index}
                subType="item"
                setDepartmentOffset={setDepartmentOffset}
                setDepartmentText={setDepartmentText}
                limit={limit}
                editItemIndex={editItemIndex}
                setIsSkuCode={setIsSkuCode}
                isSkuCode={isSkuCode}
                isAddCustomerSupplierPresent={isAddCustomerSupplierPresent}
                client_code={client_code}
                handleToggleAddCustomerSupplierModal={
                  handleToggleAddCustomerSupplierModal
                }
                calculationDetails={calculationDetails}
                currencyExchangeDetails={currencyExchangeDetails}
                clientCurrencyShortForm={clientCurrencyShortForm}
              />
            </Col>
          );
        })
      );
    }
  };

  const renderAddItem = () => {
    return (
      itemDataTemp &&
      itemDataTemp?.map((value: any, index: number) => {
        return (
          <Col
            xs={value?.column_name === "description_as_per_bill" ? "6" : "3"}
          >
            <SingleInput
              item={value}
              callback={handleItemData}
              selectOption={selectOption}
              index={index}
              setIsSkuCode={setIsSkuCode}
              isSkuCode={isSkuCode}
              setDepartmentOffset={setDepartmentOffset}
              setDepartmentText={setDepartmentText}
              limit={limit}
              subType="item"
              editItemIndex={editItemIndex}
              client_code={client_code}
              handleToggleAddCustomerSupplierModal={
                handleToggleAddCustomerSupplierModal
              }
              calculationDetails={calculationDetails}
              currencyExchangeDetails={currencyExchangeDetails}
              clientCurrencyShortForm={clientCurrencyShortForm}
              currencySign={currencySign}
              clientCurrencyName={clientCurrencyName}
            />
          </Col>
        );
      })
    );
  };

  const tabs: any = [
    { id: 1, label: "Primary Details", description: primaryDetails() },
    { id: 2, label: "Item Details", description: itemDetails() },
    { id: 3, label: "Payment Details", description: paymentDetails() },
  ];

  const handleGoBack = () => {
    type === "expenses"
      ? history?.push({
          pathname: `/invoice-generation/${client_code}#${type}`,
          state: { client_code: clientCode, company_name: companyName },
        })
      : history?.push({
          pathname: `/invoice-generation/${client_code}#${type}`,
          state: { client_code: clientCode, company_name: companyName },
        });

    localStorage.removeItem("client_code");
    localStorage.removeItem("company_name");
  };

  const handleUploadFileFromFileManager = (data: any) => {
    let newFileUploadData = JSON.parse(JSON.stringify(uploadData));
    let finalData: any = removeDuplicate(data);

    setUploadData({
      ...newFileUploadData,
      column_value: Array.from(finalData),
    });
  };

  useEffect(() => {
    if (
      loginData?.user_id ||
      singleInvoiceDetails?.approval_details?.length > 0
    ) {
      let user_id;
      if (loginData?.user_id) {
        user_id = checkSameUserId(
          loginData?.user_id,
          singleInvoiceDetails?.approval_details
        );
      }
      let totelArrpovedData =
        singleInvoiceDetails?.approval_details?.length === 3;
      setApproved(user_id || totelArrpovedData);
    }
  }, [loginData?.user_id, singleInvoiceDetails?.approval_details]);

  const handleToggleInvoiceCommentsModal = () => {
    setShowInvoiceCommentsModal(!showInvoiceCommentsModal);
  };

  useEffect(() => {
    if (showInvoiceCommentsModal) {
      let obj: any = {};
      singleInvoiceDetails?.invoice_data?.primary &&
        singleInvoiceDetails?.invoice_data?.primary?.map((data: any) => {
          if (data?.column_name === "voucher_invoice_date") {
            obj["voucher_invoice_date"] = data?.column_value;
          }
          if (data?.column_name === "voucher_invoice_number") {
            obj["voucher_invoice_number"] = data?.column_value;
          }
        });
      obj["net_amount"] = singleInvoiceDetails?.invoice_data?.net_amount;
      setInvoiceData(obj);
      if (type && invoice_id && token && client_code) {
        let finalData: GetCommentPayloadType = {
          type,
          token,
          invoice_id,
          client_code,
        };
        dispatchGetAllInvoiceCommentsAction(finalData);
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [showInvoiceCommentsModal, singleInvoiceDetails]);

  const handleSubmitInvoiceComment = (data: any) => {
    if (type && token && invoice_id) {
      let finalData: AddCommentPayloadType = {
        client_code,
        token,
        type,
        invoice_id,
        comments: data?.commentText,
      };

      dispatchPostAllInvoiceCommentsAction(finalData);
    }
  };

  const closeAddItemTab = () => {
    setShowAddModal(false);
    setShowModal(false);
    setIsSkuCode(false);
    setCalculationDetails((prev: any) => ({
      ...prev,
      itemDetailsData: {},
    }));
  };

  return (
    <>
      {imageDetails?.fileUrl?.length != 0 && (
        <SinglePreviewWithApi
          resetImageUrl={resetImageUrl}
          imageDetails={imageDetails}
          token={token}
          type="client"
          clientCode={client_code}
        />
      )}

      {showFileUploadModal && (
        <UploadModalWithFileManager
          type={"copyInvoice"}
          isDropZone={true}
          modal={showFileUploadModal}
          toggleModal={handleToggleFileUploadModal}
          client_code={client_code}
          setUploadData={setUploadData}
          uploadData={uploadData}
          token={token}
          setShowFileUploadModal={setShowFileUploadModal}
          handleUploadFile={handleUploadFile}
          handleUploadFileFromFileManager={handleUploadFileFromFileManager}
          fetching={fileManagerFetching}
          isDraggableModal
        />
      )}

      {!showOcrFileUploadModal && fetching && <Loader />}
      <Toaster />
      {handleErrorModal()}
      {showAddCustomerSupplierModal && (
        <CustomerSupplierModal
          modal={showAddCustomerSupplierModal}
          toggleModal={handleToggleAddCustomerSupplierModal}
          client_code={client_code}
          type={type}
        />
      )}

      {showNatureOfConfirmModal && (
        <ConfirmationModal
          toggle={() => {
            setNatureOfShowConfirmModal(!showNatureOfConfirmModal);
            // setNatureOfChange(false);
          }}
          isOpen={showNatureOfConfirmModal}
          title={"Are You Sure ?"}
          message={`This ${type === "revenues"?"customer":"supplier"} has a default Nature of ${type === "revenues"?"Income":"Expense"}. Use it or keep the current selection?`}
          confirmButtonText={"Confirm"}
          onPressConfirm={() => {
            // setNatureOfChange(true);
            handleChangeItemNatureOfData();
            setNatureOfShowConfirmModal(!showNatureOfConfirmModal);
          }}
        />
      )}

      {showDuplicateConfirmModal && (
        <ConfirmationModal
          toggle={() => {
            setShowDuplicateConfirmModal(!showDuplicateConfirmModal);
          }}
          isOpen={showDuplicateConfirmModal}
          title={"Found Duplicate Entry"}
          message={`Are you sure you want to Proceed`}
          confirmButtonText={"Confirm"}
          onPressConfirm={() => {
            dispatchAddInvoiceGenerationAction(checkDuplicatePayload);
            setShowDuplicateConfirmModal(!showDuplicateConfirmModal);
          }}
        />
      )}

      {showOcrFileUploadModal ? (
        <OcrDropZone
          modal={showOcrFileUploadModal}
          toggleModal={handleToggleOcrFileUploadModal}
          client_code={client_code}
          token={token}
          type="formattedFormData"
          handleUploadFile={handleOcrUploadFile}
          handleGoBack={handleGoBack}
          progressValue={progressValue}
          fetching={fetching}
          isDraggableModal
          acceptedFiles="image/png, application/pdf , image/jpeg"
          supportedFiles="images, PDF"
        />
      ) : (
        <div className="row">
          <div className="col-md-6 mb-3">
            <CommonHeader
              title={`Add ${
                type === "expenses" ? "Expense Entry" : "Sales Entry"
              }`}
            />
          </div>
          <div className="col-md-12 mt-4 invoice-accordian">
            {tabs?.map((tab: any) => (
              <Accordion key={tab.id} defaultActiveKey={tab.id}>
                <Card>
                  <Accordion.Collapse eventKey={tab.id}>
                    <Card.Body>{tab.description}</Card.Body>
                  </Accordion.Collapse>
                  <Card.Header>
                    <Accordion.Toggle
                      as={Button}
                      variant="link"
                      eventKey={tab.id}
                    >
                      <div>
                        <span>0{tab.id}</span>
                        {tab.label}
                      </div>
                      <img
                        src={DownArrow}
                        className="accordion-arrow"
                        alt="arrow"
                      />
                    </Accordion.Toggle>
                  </Card.Header>
                </Card>
              </Accordion>
            ))}

            <hr />

            <div className="text-right">
              <button
                onClick={
                  new URLSearchParams(search).get("client_code")
                    ? handleGoBack
                    : () => {
                        history?.goBack();
                      }
                }
                className="mr-3 btn btn-outline-dark"
              >
                {!isEntryLocked ? `Cancel` : `Exit`}
              </button>

              {!isEntryLocked ? (
                <Button
                  onClick={() =>
                    validateSubmitData(item, primary, payment)
                      ? handleSubmit()
                      : validate()
                  }
                >
                  {singleInvoiceDetails?.invoice_category === 2 && convert
                    ? "Convert to invoice"
                    : "Submit"}
                </Button>
              ) : null}
            </div>
          </div>

          <Modal
            isOpen={showModal}
            toggle={closeAddItemTab}
            size="xl"
            backdrop="static"
          >
            <ModalHeader
              toggle={closeAddItemTab}
              style={{ padding: "20px 20px 0px 20px" }}
            >
              <div>
                <div>
                  <div className="d-flex align-items-center">
                    <span style={{ fontSize: "18px", fontWeight: "700" }}>{`${
                      editItemIndex !== null ? "Edit" : "Add"
                    } Item Details`}</span>
                    <div className="d-flex align-items-center">
                      {currencyExchangeDetails?.baseCurrency !=
                        clientCurrencyShortForm && (
                        <span
                          style={{
                            fontWeight: "500",
                            color: "black",
                            marginLeft: "15px",
                            fontSize: "15px",
                          }}
                        >
                          {currencyExchangeDetails?.baseCurrency
                            ? `1 ${currencyExchangeDetails?.baseCurrency} = ${
                                currencyExchangeDetails?.rate
                                  ?.toString()
                                  ?.split(".")[1]?.length > 2
                                  ? (+currencyExchangeDetails?.rate)?.toFixed(2)
                                  : currencyExchangeDetails?.rate
                              } ${clientCurrencyShortForm}`
                            : ""}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <div>
                    <span style={{ fontSize: "14px", color: "GrayText" }}>
                      Add details of your product or service here.
                    </span>
                  </div>
                </div>
              </div>
            </ModalHeader>
            <ModalBody className="p-5">
              <div className="row">{renderItemInput()}</div>
            </ModalBody>
            <div>
              <hr />
              <div className="custom-modal-footer">
                {type === "revenues" && isGstPresent.revenue
                  ? (type === "revenues" && isGstPresent.revenue && (
                      <div>
                        <small style={{ color: "red" }}>
                          Note : Please choose place of supply from primary
                          section, before filling GST details
                        </small>
                      </div>
                    )) || <div></div>
                  : (type === "expenses" && isGstPresent.expense && (
                      <div>
                        <small style={{ color: "red" }}>
                          Note : Please choose place of supply from primary
                          section, before filling GST details
                        </small>
                      </div>
                    )) || <div></div>}
                <div>
                  <div className="center-flex">
                    <div
                      className="pointer mr-2"
                      onClick={() => {
                        setShowModal(false);
                        setCalculationDetails((prev: any) => ({
                          ...prev,
                          itemDetailsData: {},
                        }));
                        setIsSkuCode(false);
                      }}
                    >
                      Cancel
                    </div>
                    <div>
                      {editItemIndex === null ? (
                        <Button onClick={() => saveItemData()}>
                          Save and Add
                        </Button>
                      ) : (
                        <Button onClick={() => editItemData()}>
                          Edit Data
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

          <Modal isOpen={showAddModal} toggle={closeAddItemTab} size="xl">
            <ModalHeader
              toggle={closeAddItemTab}
              style={{ padding: "20px 20px 0px 20px" }}
            >
              <div>
                <div>
                  <div className="d-flex align-items-center">
                    <span style={{ fontSize: "18px", fontWeight: "700" }}>
                      Add Item Details
                    </span>
                    <div className="d-flex align-items-center">
                      {currencyExchangeDetails?.baseCurrency !=
                        clientCurrencyShortForm && (
                        <span
                          style={{
                            fontWeight: "500",
                            color: "black",
                            marginLeft: "15px",
                            fontSize: "15px",
                          }}
                        >
                          {currencyExchangeDetails?.baseCurrency
                            ? `1 ${currencyExchangeDetails?.baseCurrency} = ${
                                currencyExchangeDetails?.rate
                                  ?.toString()
                                  ?.split(".")[1]?.length > 2
                                  ? (+currencyExchangeDetails?.rate)?.toFixed(2)
                                  : currencyExchangeDetails?.rate
                              } ${clientCurrencyShortForm}`
                            : ""}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <div>
                    <span style={{ fontSize: "14px", color: "GrayText" }}>
                      Add details of your product or service here.
                    </span>
                  </div>
                </div>
              </div>
            </ModalHeader>
            <ModalBody className="p-5">
              <div className="row">{renderAddItem()}</div>
            </ModalBody>
            <ModalFooter>
              <hr />
              <Row>
                <Col xs="12">
                  <span
                    className="pointer mr-2"
                    onClick={() => {
                      setShowAddModal(false);
                      setIsSkuCode(false);
                      setCalculationDetails((prev: any) => ({
                        ...prev,
                        itemDetailsData: {},
                      }));
                    }}
                  >
                    Cancel
                  </span>
                  <Button onClick={() => saveItemData()}>Save and Add</Button>
                </Col>
              </Row>
            </ModalFooter>
          </Modal>
        </div>
      )}

      {showInvoiceCommentsModal && (
        <InvoiceCommentsModal
          modal={showInvoiceCommentsModal}
          toggleModal={handleToggleInvoiceCommentsModal}
          data={invoiceData}
          commentList={allComments}
          handlePostComment={handleSubmitInvoiceComment}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.invoiceGeneration.fetching,
  clientSettingsFetching: state.clientSettings.fetching,
  isDuplicateEntry: state.invoiceGeneration.isDuplicateEntry,
  error: state.invoiceGeneration.error,
  success: state.invoiceGeneration.success,
  statusCode: state.invoiceGeneration.statusCode,
  mappedExpensesColumnsList: state.invoiceGeneration.mappedExpensesColumnsList,
  mappedRevenueColumnsList: state.invoiceGeneration.mappedRevenueColumnsList,
  mappedOthersColumnList: state.invoiceGeneration.mappedOthersColumnList,
  invoiceGeneration: state.invoiceGeneration,
  clientSettings: state.clientSettings,
  branch: state.clientSettings.businessAddressList,
  allIncomeLedgersList: state.clientSettings.allIncomeLedgersList,
  allExpensesLedgersList: state.clientSettings.allExpensesLedgersList,
  allTypesLedgersList: state.clientSettings.allTypesLedgersList,
  singleInvoiceDetails: state.invoiceGeneration.singleInvoiceDetails,
  allStockItemList: state.clientSettings.allStockItemList,
  customerSupplierListTotal: state.clientSettings.customerSupplierListTotal,
  loginData: state.auth.loginData,
  commentsSuccess: state.invoiceGeneration.commentsSuccess,
  approvalSuccess: state.invoiceGeneration.approvalSuccess,
  allComments: state.invoiceGeneration.allComments,
  fileManagerFetching: state.fileManager.fetching,
  singleCustomerSupplier: state.clientSettings.singleCustomerSupplier,
  currencySign: state.auth.currencySign,
  lockedRevenueEntriesDate: state.invoiceGeneration.lockRevenueEntriesDate,
  lockedExpensesEntriesDate: state.invoiceGeneration.lockExpensesEntriesDate,
  invoiceNotesList: state.invoiceGeneration.invoiceNotesList,
  masterDataCurrencyListing: state.masterData.masterDataCurrencyListing,
  masterDataCurrencyListTotal: state.masterData.masterDataCurrencyListTotal,
  currencyExchangeDetails: state.masterData.currencyExchangeDetails,
  currencyExchangeSuccess: state.masterData.success,
  currencyExchangeError: state.masterData.error,
  clientCurrencyName: state.auth.currencyName,
  clientCurrencyShortForm: state.auth.currencyShortForm,
  userDepartmentList: state.masterData.userDepartmentList,
  userDepartmentTotalCount: state.masterData.userDepartmentTotalCount,
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
  fileUploadData: state.clientSettings.multipleFileUploadData,
  mappedStockBatchList: state.clientSettings.mappedStockBatchList,
  mappedStockBatchListTotalCount:
    state.clientSettings.mappedStockBatchListTotalCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSessionAction: () => dispatch(resetSession()),
  dispatchResetSingleInvoiceDetails: () =>
    dispatch(resetSingleInvoiceDetails()),
  dispatchGetClientColumnListAction: (data: any) =>
    dispatch(getAllMappedClientColumnListAction(data)),
  dispatchResetInvoiceStatusCode: () => dispatch(resetInvoiceStatusCode()),
  dispatchResetMappedExpensesColumnsListAction: () =>
    dispatch(resetMappedExpensesColumnList()),
  dispatchResetMappedRevenueColumnListAction: () =>
    dispatch(resetMappedRevenueColumnList()),
  dispatchResetUpdateInvoiceGenerationSuccess: () =>
    dispatch(resetUpdateInvoiceGenerationSuccess()),
  dispatchResetUpdateInvoiceGenerationError: () =>
    dispatch(resetUpdateInvoiceGenerationError()),
  dispatchGetAllBusinessAddressAction: (data: any) =>
    dispatch(getAllBusinessAddressAction(data)),
  dispatchGetAllCustomerSupplierAction: (data: any) =>
    dispatch(getAllCustomerSupplierAction(data)),
  dispatchGetAllLedgersListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getAllLedgersListAction(data)),
  dispatchResetIsDuplicateInvoice: () => dispatch(resetDuplicateEntry()),
  dispatchAddInvoiceGenerationAction: (data: AddInvoiceGenerationPayloadType) =>
    dispatch(addInvoiceGenerationAction(data)),
  dispatchGetAllIncomeLedgersListAction: (data: any) =>
    dispatch(getAllIncomeLedgersListAction(data)),
  dispatchGetAllExpensesLedgersListAction: (data: any) =>
    dispatch(getAllExpensesLedgersListAction(data)),
  dispatchGetSingleInvoiceDetailsAction: (data: any) =>
    dispatch(getSingleInvoiceDetailsAction(data)),
  dispatchGetAllTypesLedgerListAction: (data: any) =>
    dispatch(getAllTypesLedgerListAction(data)),
  dispatchGetAllStockItem: (data: GetAllStockItemListPayloadType) =>
    dispatch(getAllStockItemListAction(data)),
  dispatchResetCustomerSupplierList: () =>
    dispatch(resetCustomerSupplierList()),
  dispatchCheckDuplicateEntryAction: (data: DuplicateEntriesPayloadType) =>
    dispatch(checkDuplicateEntryAction(data)),
  dispatchApproveInvoice: (data: ApproveInvoicePayloadType) =>
    dispatch(approveInvoiceAction(data)),
  dispatchResetApprovalSuccess: () => dispatch(resetApprovalSuccess()),
  dispatchResetCommentsSuccess: () => dispatch(resetcommentsSuccess()),
  dispatchGetAllInvoiceCommentsAction: (data: GetCommentPayloadType) =>
    dispatch(getInvoiceAllComment(data)),
  dispatchPostAllInvoiceCommentsAction: (data: AddCommentPayloadType) =>
    dispatch(postInvoiceAllComment(data)),
  dispatchPostInvoiceOcrAction: (data: GetSingleInvoiceDetailsOcrPayloadType) =>
    dispatch(postInvoiceOcrAction(data)),
  dispatchResetSingleCustomerSupplier: () =>
    dispatch(resetSingleCustomerSupplier()),
  dispatchInvoiceNotesList: (data: InvoiceNotesPayloadType) =>
    dispatch(invoiceNotesListAction(data)),
  dispatchResetInvoiceNotesList: () => dispatch(resetInvoiceNotesList()),
  dispatchGetAllMasterDataCurrencyList: (
    data: GetAllMasterDataCurrencyPayloadType
  ) => dispatch(getAllMasterDataCurrencyAction(data)),
  dispatchGetCurrencyExchangeAction: (
    data: GetCurrencyExchangeDetailsPayloadType
  ) => dispatch(getCurrencyExchangeAction(data)),
  dispatchResetCurrencyExchangeDetails: () =>
    dispatch(resetCurrencyExchangeDetails()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) =>
    dispatch(multipleUploadFilesAction(data)),
  dispatchResetMultiFileUploadData: () =>
    dispatch(resetMultipleFileUploadData()),
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataUsersDepartmentAction(data)),
  dispatchGetStockMappedBatchListAction: (
    data: GetStockMappedBatchListPayloadType
  ) => dispatch(getStockMappedBatchListAction(data)),
  dispatchResetMappedStockBatchList: () =>
    dispatch(resetMappedStockBatchList()),
  dispatchResetMappedStockBatchListTotalCount: () =>
    dispatch(resetMappedStockBatchListTotalCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddOcrInvoice);
